var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup43080({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.057,
    height: 139.227,
    viewBox: "0 0 168.057 139.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43080",
    "data-name": "Group 43080",
    transform: "translate(-876 -402.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72136",
    "data-name": "Path 72136",
    d: "M1813.04,338.43a7.334,7.334,0,0,0,1.579,4.28c1.855,1.926,5.582,1.911,7.734.312a3.97,3.97,0,0,0,1.422-1.866,9.879,9.879,0,0,0,.377-3.308c0-7.341-3.366-15.607-1.641-22.475a12.665,12.665,0,0,1,1.645-3.83c1.09-1.689-.034-3.01-.937-4.193a5.531,5.531,0,0,0-3.894-1.846,5.971,5.971,0,0,0-4.382,1.077,6.063,6.063,0,0,0-1.82,3.511c-.063.285-.117.572-.167.854-1.61,9.069-1.148,18.361.085,27.483",
    transform: "translate(-886.312 105.176)",
    fill: "#492822"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72137",
    "data-name": "Path 72137",
    d: "M1906.587,650.365a32.622,32.622,0,0,0,4.777,4.317,4.113,4.113,0,0,0,1.422-1.94,10.651,10.651,0,0,0,.377-3.438c0-7.63-3.366-16.222-1.641-23.36l-7.688.319s-1.936,18.85,2.753,24.1",
    transform: "translate(-975.322 -206.531)",
    fill: "#3a221d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72138",
    "data-name": "Path 72138",
    d: "M1933.147,346.9l.032-.03a1.3,1.3,0,0,0,.29-.729,19.846,19.846,0,0,0,.219-6.165,10.445,10.445,0,0,0-2.486-5.573c-2.865-3.124-7.728-2.884-11.538-2.046a9.213,9.213,0,0,0-5.162,2.883,9.889,9.889,0,0,0-1.983,5.039,15.634,15.634,0,0,0,2.881,11.547.563.563,0,0,0,.263.223.574.574,0,0,0,.319-.03l16.621-4.869a1.415,1.415,0,0,0,.544-.248",
    transform: "translate(-984.007 79.549)",
    fill: "#664432"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72139",
    "data-name": "Path 72139",
    d: "M2470.039,4916.207h-14.374a.383.383,0,0,1-.375-.3c0-.049,0-.107,0-.175h0c0-.16.01-.374.018-.657,0-.168.01-.363.017-.587a5.865,5.865,0,0,1,.672-2.731c1.869,1.485,5.366.767,6.276.19a5.187,5.187,0,0,1,.561-.313c.472-.221.636-.165.636-.165a10.546,10.546,0,0,0,3.545,2.3c1.629.432,3.258,0,3.594.911a1.4,1.4,0,0,1-.575,1.533",
    transform: "translate(-1512.064 -4374.707)",
    fill: "#dee8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72140",
    "data-name": "Path 72140",
    d: "M2470.039,5030.489h-14.374a.384.384,0,0,1-.375-.3c0-.05,0-.108,0-.176,0,0,0,0,0,0,0-.16.01-.374.018-.657a10.915,10.915,0,0,1,2.412-.108c1.486.144,4.313.575,6.421.671s5.846.145,6.468-.958a1.4,1.4,0,0,1-.575,1.533",
    transform: "translate(-1512.064 -4488.988)",
    fill: "#6f7a9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72141",
    "data-name": "Path 72141",
    d: "M2488.073,4704.209a5.039,5.039,0,0,0-.562.313c-.91.576-4.408,1.294-6.276-.191,0,0,.431-.1.79-.886s-.215-5.247-.215-5.247h4.06c.108,0-.107,2.012,0,3.163.076.809,1.416,2.135,2.2,2.848",
    transform: "translate(-1537.299 -4167.287)",
    fill: "#353c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72142",
    "data-name": "Path 72142",
    d: "M1972.047,4916.612c0,.065.009.133.018.2a1.208,1.208,0,0,0,.559,1,1.5,1.5,0,0,0,.656.1l6.517-.018a.921.921,0,0,0,.472-.085.86.86,0,0,0,.331-.627q.025-.141.04-.28a6,6,0,0,0-.863-3.636c-.149.068-.3.133-.452.19a8.069,8.069,0,0,1-5.89-.055c-.148-.06-.294-.124-.437-.192-.01.017-.021.031-.031.049a5.622,5.622,0,0,0-.921,3.354",
    transform: "translate(-1042.046 -4376.41)",
    fill: "#dee8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72143",
    "data-name": "Path 72143",
    d: "M2022.983,4704.405a8.082,8.082,0,0,0,5.89.055,17.434,17.434,0,0,1-1.312-3.661v-2.471h-3.74v2.2a26.481,26.481,0,0,1-.838,3.88",
    transform: "translate(-1091.594 -4167.414)",
    fill: "#353c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72144",
    "data-name": "Path 72144",
    d: "M1972.934,5039.862a1.208,1.208,0,0,0,.559,1,1.5,1.5,0,0,0,.656.1l6.517-.018a.922.922,0,0,0,.472-.085.859.859,0,0,0,.331-.627c.016-.094.03-.187.04-.28a4.567,4.567,0,0,1-2.715.133c-1.456-.486-1.311-.45-3.107-.079a5.391,5.391,0,0,1-2.754-.143",
    transform: "translate(-1042.916 -4499.461)",
    fill: "#6f7a9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72145",
    "data-name": "Path 72145",
    d: "M2588.888,835.911s1.875-.546,2.66.409.068,3.888-1.33,4.536a3.85,3.85,0,0,1-3.1-.341Z",
    transform: "translate(-1640.28 -410.598)",
    fill: "#e8887c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72146",
    "data-name": "Path 72146",
    d: "M2013.834,4879.591s-2.5-2.222-6.778-.056c0,0,2.976,3.339,6.778.056",
    transform: "translate(-1076.104 -4342.736)",
    fill: "#dee8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72147",
    "data-name": "Path 72147",
    d: "M2672.526,4879.184s-.791-1.019-1.541-.906a.489.489,0,0,0-.352.277s.311,1.137-.407,1.53c0,0,1.731.456,2.3-.9",
    transform: "translate(-1721.115 -4342.428)",
    fill: "#dee8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72148",
    "data-name": "Path 72148",
    d: "M2246.951,1126.145v4.7c0,.063,0,.125-.007.187a1.815,1.815,0,0,1-1.587,1.849h-.385a1.682,1.682,0,0,1-1.5-1.364,2.531,2.531,0,0,1-.09-.672v-4.7a1.862,1.862,0,0,1,1.594-2.036h.385a1.863,1.863,0,0,1,1.594,2.036",
    transform: "translate(-1305.955 -691.057)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72149",
    "data-name": "Path 72149",
    d: "M1855.84,473.573a1.672,1.672,0,0,1,2.072.292l2.649-3.7c9.369-1.564,11.191-6.515,11.191-6.515a7.8,7.8,0,0,1,4.89,5.23,15.264,15.264,0,0,1,.476,4.753,25.985,25.985,0,0,1-.236,2.719,23.584,23.584,0,0,1-.561,2.809.02.02,0,0,0,0,.009c-.1.367-.206.722-.318,1.061a.025.025,0,0,0-.006.01,8.491,8.491,0,0,1-1.34,2.654,3.082,3.082,0,0,1-.459.452,8.116,8.116,0,0,1-3.029,1.289c-2.816.663-6.473.537-8.689-.822a8.767,8.767,0,0,1-3.913-4.722,3.62,3.62,0,0,1-2.174.18c-.97-.324-1.715-1.974-1.779-2.75s-.13-2.331,1.229-2.944",
    transform: "translate(-927.805 -48.676)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72150",
    "data-name": "Path 72150",
    d: "M2407.064,880.529a3.314,3.314,0,1,0,3.308-3.117,3.217,3.217,0,0,0-3.308,3.117",
    transform: "translate(-1465.158 -451.113)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72151",
    "data-name": "Path 72151",
    d: "M2064.343,880.529a3.208,3.208,0,1,0,3.206-3.117,3.163,3.163,0,0,0-3.206,3.117",
    transform: "translate(-1131.821 -451.113)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72152",
    "data-name": "Path 72152",
    d: "M2648.445,1030.055a.069.069,0,0,1,0,.012.019.019,0,0,1,0-.009Z",
    transform: "translate(-1699.93 -599.576)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72153",
    "data-name": "Path 72153",
    d: "M1855.832,826.2a3.759,3.759,0,0,0-.022,3.777,2.4,2.4,0,0,0,3.439.608,8.056,8.056,0,0,0,5.681,5.668,13.676,13.676,0,0,0,6.541.154,6.061,6.061,0,0,0,4.517-3.544,8.5,8.5,0,0,1-1.341,2.654,2.96,2.96,0,0,1-.459.451c-.083.065-.172.127-.265.188l-.085.054c-.068.043-.138.086-.21.128l-.1.056q-.112.061-.229.12l-.1.048q-.146.07-.3.136l-.043.019q-.187.079-.386.152l-.013,0c-.124.045-.251.089-.381.13l-.079.025q-.168.053-.341.1l-.086.024q-.187.051-.38.1l-.034.009h0c-2.816.663-6.472.537-8.689-.822a8.765,8.765,0,0,1-3.913-4.722,3.621,3.621,0,0,1-2.174.18c-.97-.323-1.715-1.974-1.779-2.751s-.13-2.33,1.229-2.944",
    transform: "translate(-927.796 -401.301)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72160",
    "data-name": "Path 72160",
    d: "M2525.76,1357.278s6.842,5.8,8.717,14.1l-2,1.941Z",
    transform: "translate(-1580.605 -917.84)",
    fill: "#332d2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72161",
    "data-name": "Path 72161",
    d: "M2363.256,1467.991l-1.7.907-1.375.734-1.435.767-.52.278-.437.233-1.966,1.051-2.235,1.194-11.939,6.378-5.5-14.617-1.649-4.384,2.613-1.308,8.235-4.123,8.538-4.274Z",
    transform: "translate(-1394.588 -1008.828)",
    fill: "#dee8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72162",
    "data-name": "Path 72162",
    d: "M2957.286,2106.739v0c0,.019-.019.167-.06.375a3.255,3.255,0,0,1-.548,1.362,1.071,1.071,0,0,1-.166.161l-.011.01-.013.011a4.024,4.024,0,0,1-1.024,1.035c-.312.2-.7.191-1.033.394a2.159,2.159,0,0,1-.728.4,1.282,1.282,0,0,1-.7-.145,8.306,8.306,0,0,1-.93-.469,8.624,8.624,0,0,1-1.844-1.453.875.875,0,0,1-.263-.42.322.322,0,0,1,.229-.386.727.727,0,0,1-.351-.517.682.682,0,0,1,.047-.4.735.735,0,0,1,.887-.375.271.271,0,0,1-.14-.334.52.52,0,0,1,.269-.282,1.838,1.838,0,0,1,1.343-.014c1.491.407,2.885,1.222,4.428,1.328a.414.414,0,0,1,.095.013Z",
    transform: "translate(-1993.063 -1645.646)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72163",
    "data-name": "Path 72163",
    d: "M3195.217,2120.453a1.07,1.07,0,0,1-.253.62c-.357.4-.824.069-1.117.662a3.539,3.539,0,0,1-.613.846c-.075.076-.134.132-.165.161l-.012.01-.013.011.219-1.267.062-.36.518-.293,1.363-.771a1.5,1.5,0,0,1,.011.38",
    transform: "translate(-2229.619 -1659.75)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72164",
    "data-name": "Path 72164",
    d: "M1901.505,837.1a1.323,1.323,0,0,1,1.63.169,2.681,2.681,0,0,1,.816,1.322l-.627.124s-.239-1.7-1.819-1.615",
    transform: "translate(-973.442 -411.699)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72165",
    "data-name": "Path 72165",
    d: "M1889.639,2729.4a100.349,100.349,0,0,1-.406,11.5c-.6,4.232-.743,13.754-.743,13.754h-4.167v0h-2.143s-1.479-18.017-1.347-23.906c0-.063,0-.127,0-.187.114-3.81-1.047-12.871-1.824-18.432a.132.132,0,0,0,0-.014l0-.03c0,.01,0,.02,0,.03-.052.982-.1,1.978-.155,2.963l-.092,1.7v0c-.127,2.346-.252,4.567-.365,6.357-.057.917-.111,1.72-.159,2.371s-.088,1.134-.122,1.432c-.182,1.579-.307,3.185-.479,4.819a45.612,45.612,0,0,1-.7,4.7c-.675,3.213-.917,17.593-.927,18.177a.1.1,0,0,0,0,.021h-4.375a6.4,6.4,0,0,1-2.091,0c-.541-.23-.55-.623-.737-1.357a31.919,31.919,0,0,1-.772-9.127c.139-3.536.611-7.04.842-10.569.074-1.145.108-2.425.1-3.8a136.7,136.7,0,0,0-1.514-18.56q-.157-1.054-.329-2.049c-.213-1.252-.439-2.427-.673-3.5-.033-.155-.067-.308-.1-.458s-.075-.327-.113-.486c0,0-.179-1.114-.307-2.817a42.47,42.47,0,0,1-.079-5.315H1889.6l.028,5.377.014,2.755,0,.4v.057l-.038,4.529v17.2s.022.985.035,2.466",
    transform: "translate(-938.722 -2220.518)",
    fill: "#563952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72166",
    "data-name": "Path 72166",
    d: "M1843.189,1359.926v3.819c-.449.07-.9.133-1.348.193q-.55.073-1.1.136-.528.063-1.053.118a93.816,93.816,0,0,1-11.1.475l-.09,0c-1.33-.019-2.589-.063-3.759-.121-2.631-.132-4.809-.336-6.319-.505q-.622-.07-1.087-.129c-.708-.088-1.125-.153-1.2-.164h-.012v-2.78q-.014-.344,0-.72v-.319a.164.164,0,0,1,.018-.005c0-.063.01-.126.016-.191,0-.018,0-.036,0-.054.008-.083.016-.167.026-.251s.019-.17.031-.256.019-.155.031-.232c0-.026.006-.054.012-.082.01-.07.021-.142.032-.214.014-.089.029-.179.045-.271.11-.639.256-1.315.429-2.019.026-.1.05-.2.077-.305s.051-.2.079-.3.055-.2.083-.309c.033-.124.068-.251.1-.377.053-.188.105-.378.161-.567l.038-.131.056-.189q.142-.481.292-.97c.1-.325.2-.654.309-.984l.011-.034c.053-.167.108-.337.162-.5.039-.12.078-.241.117-.363l.238-.724c.041-.121.08-.241.12-.362a.01.01,0,0,1,0,0,30.853,30.853,0,0,1,3.1-4.391c.18-.214.365-.431.557-.649,0,0,1.666-1.577.23-4.309-.368-.7-.828-1.585-1.293-2.584,0-.091,0-.181-.005-.272,0-.066,0-.131,0-.2,0-.022,0-.045,0-.064,0-.159-.009-.317-.016-.477a.268.268,0,0,0,0-.034c-.008-.156-.014-.311-.022-.467-.021-.392-.046-.78-.077-1.166,0-.02,0-.038,0-.058s0-.017,0-.026c-.017-.227-.036-.452-.056-.677-.016-.191-.034-.381-.052-.571-.006-.066-.012-.131-.019-.2-.009-.11-.021-.222-.032-.331-.015-.146-.029-.291-.045-.435s-.028-.292-.043-.436c-.078-.767-.154-1.505-.217-2.208-.005-.052-.01-.108-.015-.16-.009-.1-.016-.2-.024-.3s-.016-.179-.022-.268-.009-.15-.015-.225c-.008-.106-.016-.213-.021-.318,0-.06-.008-.12-.01-.182-.005-.113-.012-.228-.017-.34-.005-.169-.009-.336-.012-.5a7.436,7.436,0,0,1,.552-2.915h0a8.866,8.866,0,0,1,2.725-3.584l.012-.009,0,0c.233-.069.5-.144.8-.221q.27-.07.573-.139c.4-.091.837-.181,1.307-.26.43-.073.888-.136,1.368-.186a18.663,18.663,0,0,1,3.573-.036c.474.043.955.107,1.44.2q.521.1,1.048.231c.44.115.881.252,1.32.414a57,57,0,0,1,4.53,6.587c.375.654.721,1.314,1.016,1.955a0,0,0,0,0,0,0s0,0,0,0h0a.063.063,0,0,0,0,.008c.04.084.077.167.115.252l.068.156a.067.067,0,0,0,.005.015c.134.31.254.615.355.91.085.241.156.476.216.7l.035.135c.011.045.023.09.032.133a7.637,7.637,0,0,1,.114,3.818c-.018.062-.037.122-.058.181h0a4.585,4.585,0,0,1-.86,1.467,21.8,21.8,0,0,1-1.551,1.575,3.2,3.2,0,0,0-1.094,2.412h0a4.03,4.03,0,0,0,.06.636,14.891,14.891,0,0,0,1.668,3.994,18.766,18.766,0,0,1,.793,1.752q.208.521.4,1.092a45.569,45.569,0,0,1,2.039,10.243l.016,0,.078.015",
    transform: "translate(-890.398 -882.521)",
    fill: "#dee8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72167",
    "data-name": "Path 72167",
    d: "M2187.657,1296.629v.026a3.811,3.811,0,0,1-.064.666,4.092,4.092,0,0,1-.1.419,3.329,3.329,0,0,1-2.856,2.491,2.841,2.841,0,0,1-3.091-1.66,5.749,5.749,0,0,1-.365-.837,6.532,6.532,0,0,1-.2-.714l0-.021c-.03-.135-.042-.217-.042-.217s.091-.022.23-.064l.112-.036a3.069,3.069,0,0,0,1.132-.631l.035-.036a1.011,1.011,0,0,0,.2-.315h3.573a3.5,3.5,0,0,0,.7.611,2.168,2.168,0,0,0,.739.32",
    transform: "translate(-1245.221 -857.947)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72168",
    "data-name": "Path 72168",
    d: "M1860.857,1705.182q-.027.1-.057.2h0a5.169,5.169,0,0,1-.846,1.6,5.84,5.84,0,0,0-.114,4.694,4.578,4.578,0,0,1,.222.59l-2.709-.928c-.41-.05-.831-.095-1.26-.131a25.928,25.928,0,0,0-3.082-.078,17.838,17.838,0,0,0-5.888,1.141,12.456,12.456,0,0,0-4.17,2.667,25.154,25.154,0,0,0-7.23,16.917q-.014-.376,0-.787c0-.115.01-.233.018-.354.005-.088.012-.177.019-.268s.015-.183.025-.275.019-.186.03-.281.019-.168.03-.253c0-.029.007-.059.012-.089.01-.078.021-.156.031-.235.014-.1.029-.2.044-.3.108-.7.252-1.436.423-2.206.025-.111.049-.22.075-.332s.051-.222.078-.334.053-.225.081-.338c.033-.135.067-.273.1-.411.052-.206.1-.413.159-.62.03-.117.06-.233.092-.35.093-.35.189-.7.287-1.059s.2-.715.3-1.075c.056-.2.112-.393.17-.589l.115-.4q.117-.4.234-.792c.04-.132.078-.263.118-.4a.016.016,0,0,1,0,0c.643-2.156,1.3-4.3,1.828-6.234a24.97,24.97,0,0,0,.723-6.806c0-.171-.005-.341-.01-.511,0-.025,0-.049,0-.071,0-.174-.01-.347-.016-.521a.363.363,0,0,0,0-.037c-.005-.171-.014-.34-.022-.509q-.031-.643-.075-1.275c0-.03,0-.062-.006-.092-.016-.247-.036-.494-.055-.74-.016-.209-.033-.417-.051-.625-.007-.072-.012-.144-.019-.214-.01-.121-.021-.243-.031-.363-.029-.321-.057-.639-.086-.951a16.505,16.505,0,0,0,1.646,1.767,9.04,9.04,0,0,0,5.131,2.021,23,23,0,0,0,3.989.1,34.518,34.518,0,0,0,7.994-1.389c2.041-.714.879-4.994.824-5.185v0a.025.025,0,0,0,0,.007c.038.092.075.183.112.276.025.063.048.125.073.187.131.338.249.672.349.994.083.263.153.521.212.77.011.047.023.1.034.148s.022.1.031.145a9.255,9.255,0,0,1,.112,4.172",
    transform: "translate(-909.452 -1249.701)",
    fill: "#c5d6ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72169",
    "data-name": "Path 72169",
    d: "M1986.213,1648.538s-1.147,5.515,2.321,7.553c0,0-4.636-.794-5.416-3.5Z",
    transform: "translate(-1052.82 -1201.125)",
    fill: "#17c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72170",
    "data-name": "Path 72170",
    d: "M1819.694,1357.352v7.973l-2.108,3.689-.6,1.057-.337-.214-2.809-1.791-1.924-1.227s1.114-1.813,2.162-3.765c.525-.978,1.033-1.991,1.377-2.828a3.92,3.92,0,0,1,.726-1.146,6.241,6.241,0,0,1,3.447-1.737l.07-.01",
    transform: "translate(-886.302 -917.912)",
    fill: "#1bcece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72171",
    "data-name": "Path 72171",
    d: "M2484.45,420.277a1.286,1.286,0,0,0,.05.888,6.045,6.045,0,0,0,1.843,1.974,9.782,9.782,0,0,1,2.585,10.6c2.046-2.213,1.7-6.442.76-9.043a7.452,7.452,0,0,0-4.171-4.744,1.039,1.039,0,0,0-.729-.049.608.608,0,0,0-.338.372",
    transform: "translate(-1540.371 -6.086)",
    fill: "#492822"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72172",
    "data-name": "Path 72172",
    d: "M1960.194,407.369c-.018.048-.038.1-.058.143a11.825,11.825,0,0,1-7.186,6.282c-.939.316-1.911.536-2.826.915a4.882,4.882,0,0,0-2.322,1.778c-.752,1.187-.421,2.247-.124,3.472a9.566,9.566,0,0,1-1.9-3.866,6.3,6.3,0,0,1,.182-4.482,7.782,7.782,0,0,1,2.85-2.91,15.607,15.607,0,0,1,10.155-2.865c.528.058,1.149.231,1.31.737a1.213,1.213,0,0,1-.084.8",
    transform: "translate(-1016.193 7.621)",
    fill: "#492822"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72173",
    "data-name": "Path 72173",
    d: "M1633.23,1486.47s-9.726,2.283-12.3-1.546,1.756-27.894,10.829-29.978Z",
    transform: "translate(-699.838 -1012.834)",
    fill: "#9e8b98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72174",
    "data-name": "Path 72174",
    d: "M1829.952,1373.354c-.018.5-.04,1.016-.067,1.544-.013.286-.029.577-.045.87q-.029.53-.063,1.07c-.073,1.194-.162,2.425-.257,3.65q-.06.775-.125,1.543c-.024.291-.049.581-.073.869q-.047.539-.094,1.07c-.043.491-.087.974-.132,1.445-.344,3.728-.679,6.769-.774,7.624-.017.156-.027.24-.027.24l-3.742-.367-6.81-.669-1.617-.159-.011,0s0-.359,0-1.01c0-.722.01-1.8.032-3.147.019-1.111.046-2.4.088-3.827q.015-.522.034-1.069c.009-.285.019-.575.03-.868q.015-.408.032-.824c.009-.238.019-.477.03-.719.047-1.119.1-2.284.172-3.476.019-.354.041-.712.063-1.071q.027-.433.055-.869c.034-.512.07-1.029.107-1.546.091-1.245.2-2.5.314-3.747q.05-.539.105-1.074.045-.438.092-.872h0q.057-.522.118-1.041.03-.255.059-.509.125-1.108.231-2.187.052-.543.1-1.077.041-.441.077-.875.066-.787.123-1.552.07-.937.125-1.837.031-.507.06-1,.03-.546.057-1.074c.015-.3.029-.586.041-.872q.035-.8.06-1.549c0-.078.005-.156.008-.233.022-.653.038-1.277.05-1.866a17.729,17.729,0,0,0,1.451-1.928h0a6.825,6.825,0,0,1,3.758-1.617.059.059,0,0,1,.012-.009l0,0c.229-.071.492-.149.785-.228.442,1.4,1.043,3.314,1.686,5.422.152.5.307,1,.461,1.519q.129.425.257.854.157.525.313,1.053c.276.932.549,1.866.81,2.779q.221.773.428,1.52.122.434.237.856.146.54.282,1.053c.229.867.432,1.673.6,2.386.134.575.243,1.09.323,1.531q.03.166.055.317c.027.165.05.348.07.546.032.317.056.674.071,1.067.043,1.084.029,2.438-.025,3.947",
    transform: "translate(-890.39 -909.307)",
    fill: "#40373c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72175",
    "data-name": "Path 72175",
    d: "M2013.991,2524.893l.462.456s.084,2.816-4.407,5.59l-.42-3.023Z",
    transform: "translate(-1078.603 -2053.486)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72176",
    "data-name": "Path 72176",
    d: "M1928.265,2348s1.836,1.387,1.794,1.843-3.736,4.265-4.743,3.768-1.207-3.375-1.207-3.375-.892-4.2-.766-4.286,2.812-1.035,2.812-1.035l1.889,1.077Z",
    transform: "translate(-994.671 -1878.438)",
    fill: "#423f40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72177",
    "data-name": "Path 72177",
    d: "M1700.927,1444.8l-.945-.652c-.85-.187-3.21,2.888-3.21,2.888s-1.322.652-2.078,0c-.143-.125-.418-.394-.767-.76-.259-.272-.562-.6-.883-.96-1.512-1.7-3.45-4.148-3.45-5.268,0-1.677,2.267-14.349,3.117-17.8a10.628,10.628,0,0,1,2.25-4.156,13.631,13.631,0,0,1,1.811-1.807s0,.009.009.027c.05.146.294.883.56,1.935h0c.144.57.293,1.234.422,1.945a19.409,19.409,0,0,1,.332,3.36c0,.433-.022.964-.062,1.561-.1,1.515-.306,3.455-.53,5.307-.388,3.22-.824,6.175-.824,6.175s.571.6,1.294,1.406a22.843,22.843,0,0,1,2.956,3.718,7.9,7.9,0,0,1,0,3.075",
    transform: "translate(-767.333 -975.238)",
    fill: "#332d2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72178",
    "data-name": "Path 72178",
    d: "M2474.59,1385.457l-3.374.427-1.407.178s-.387-3.206-.884-7.41c-.059-.5-.12-1.015-.182-1.54q-.063-.527-.125-1.067-.051-.431-.1-.867c-.059-.509-.119-1.024-.179-1.541-.146-1.252-.292-2.517-.435-3.751q-.062-.539-.121-1.067c-.033-.291-.066-.58-.1-.865-.06-.525-.117-1.04-.174-1.54-.169-1.514-.321-2.9-.442-4.05-.04-.382-.077-.738-.109-1.066s-.061-.607-.084-.865-.045-.5-.06-.7c-.02-.25-.048-.532-.083-.841-.08-.721-.2-1.591-.344-2.553-.051-.342-.106-.7-.163-1.06q-.067-.424-.138-.862c-.081-.5-.166-1.011-.253-1.53-.156-.924-.321-1.868-.486-2.8q-.094-.534-.189-1.06-.079-.434-.156-.86c-.1-.525-.19-1.037-.28-1.529-.538-2.906-.966-5.093-.966-5.093l1.7.431a21.65,21.65,0,0,1,3.114,4.433c.158.277.32.569.485.876q.165.307.324.621.209.416.407.845.235.512.455,1.043a28.32,28.32,0,0,1,.972,2.77q.22.748.4,1.521.1.426.188.859.107.525.194,1.059.216,1.31.31,2.669c.033.509.054,1.024.06,1.542,0,.275,0,.551,0,.828,0,.013,0,.027,0,.041,0,.309,0,.668.009,1.069.03,1.106.118,2.535.241,4.14.038.5.08,1.013.125,1.54q.036.428.075.866.047.528.095,1.067c.116,1.25.241,2.54.37,3.816.052.517.105,1.032.158,1.541q.046.437.091.867.056.54.114,1.068c.5,4.638.952,8.393.952,8.393",
    transform: "translate(-1520.296 -902.543)",
    fill: "#40373c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72182",
    "data-name": "Path 72182",
    d: "M2334.87,2926.975l-.364-9.442s2.862,13.364,2.962,15.583-.765,12.305-.765,12.305Z",
    transform: "translate(-1394.588 -2435.377)",
    fill: "#3f293d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72183",
    "data-name": "Path 72183",
    d: "M1899.171,2902.388l0,.4v.056a153.076,153.076,0,0,1-23.286.033c-.037-.165-.075-.327-.113-.486,0,0-.078-.484-.168-1.3l6.81.669,3.742.367s.01-.084.027-.24c.033-.292.093-.842.173-1.587l.09,0a93.893,93.893,0,0,0,11.1-.474c.139,1.158.222,1.847.222,1.847l1.406-.178Z",
    transform: "translate(-948.246 -2418.148)",
    fill: "#3f293d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72184",
    "data-name": "Path 72184",
    d: "M2154.419,1330.869l-.027.067a5.307,5.307,0,0,1-.194,1.073,3.946,3.946,0,0,1-4.006,3.128,4.007,4.007,0,0,1-3.405-1.493,5.484,5.484,0,0,1-.867-1.781c-.088-.294-.156-.577-.214-.831-.009-.036-.016-.072-.024-.108l.048-.011.227-.051c.137-.029.279-.058.424-.087.2-.039.4-.077.608-.111l-.111.036c-.139.043-.231.064-.231.064s.011.081.042.217l0,.021a6.416,6.416,0,0,0,.2.714,5.781,5.781,0,0,0,.365.837,2.841,2.841,0,0,0,3.091,1.66,3.328,3.328,0,0,0,2.856-2.491,4.036,4.036,0,0,0,.1-.419,3.774,3.774,0,0,0,.064-.666q.521.1,1.048.231",
    transform: "translate(-1210.935 -891.93)",
    fill: "#fb5151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72185",
    "data-name": "Path 72185",
    d: "M1952.725,1343.028a19.4,19.4,0,0,1-4.418,9.718s.437-2.955.824-6.175c.224-1.852.431-3.793.53-5.307.039-.6.062-1.128.062-1.561a19.4,19.4,0,0,0-.332-3.36c.148-2.208.2-4.076.16-4.468-.088-.9,2.677-1.69,3.173-1.785a1.613,1.613,0,0,1,1.034.276,86.381,86.381,0,0,1-1.034,12.662",
    transform: "translate(-1018.963 -891.383)",
    fill: "#bfafb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72186",
    "data-name": "Path 72186",
    d: "M2483.9,1334.432s-.579-9.779-.632-10.919a5.415,5.415,0,0,0-1.184-2.505l-.006-.008a3.721,3.721,0,0,1,1.822,1.2,3.284,3.284,0,0,1,.143.984c.178,2.95-.143,11.25-.143,11.25",
    transform: "translate(-1538.12 -882.555)",
    fill: "#494546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72187",
    "data-name": "Path 72187",
    d: "M1960.626,1317.475s-4.361-8.638-4.966-9.395a27.283,27.283,0,0,0-3.775-2.724s.392-1.887,1.063-2.04.863.094,1.561-.6,2.678-.485,2.678-.485a123.431,123.431,0,0,1,3.44,15.24",
    transform: "translate(-1022.442 -864.277)",
    fill: "#332d2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72188",
    "data-name": "Path 72188",
    d: "M2148.175,1289.112v.18a1,1,0,0,1-.2.315l-.035.036a3.07,3.07,0,0,1-1.132.631c-.21.035-.413.073-.608.111q-.218.043-.424.087l-.275-.974a24.73,24.73,0,0,1,2.675-.388",
    transform: "translate(-1210.756 -851.541)",
    fill: "#332d2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72189",
    "data-name": "Path 72189",
    d: "M2378.461,1307.212s-.579-9.779-.632-10.919a5.413,5.413,0,0,0-1.184-2.505l-.006-.008h0s-.709-.253-1.295-.514a3.181,3.181,0,0,0-1.379-.178l0,0,0,0c-.1-.027-.194-.052-.294-.073v.073a3.526,3.526,0,0,0,.673.592c.263.4.623.948.949,1.4.605.841,3.168,12.132,3.168,12.132",
    transform: "translate(-1432.68 -855.336)",
    fill: "#332d2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72190",
    "data-name": "Path 72190",
    d: "M4999.62,256.8v29.341a19.843,19.843,0,0,1-4.316,3.414,15.791,15.791,0,0,1-14.215.7h0a18.281,18.281,0,0,1-3.96-2.18s-.824-7.717-1.367-15.827c-.342-5.07-.576-10.3-.434-13.89a.438.438,0,0,1,0-.065c-.035-.548-.192-4.386,1.771-5.931,2.111-1.667,10.1-7.439,20.575-.433a4.008,4.008,0,0,1,1.653,2.507,5.264,5.264,0,0,1,.3,2.366",
    transform: "translate(-3963.061 160.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72191",
    "data-name": "Path 72191",
    d: "M5100.707,847.064c.022,5.97-.2,18.385-1.163,22.124a15.792,15.792,0,0,1-14.216.7h0c-3.339-2.119-2.842-25.4-2.842-25.4Z",
    transform: "translate(-4067.301 -419.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72192",
    "data-name": "Path 72192",
    d: "M4990.226,844.657s-4.191-.558-3.951-3.351,1.928-4.644,2.65-3.82a14.143,14.143,0,0,1,1.3,1.789l1.542,5.382Z",
    transform: "translate(-3973.742 -412.088)",
    fill: "#e8887c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72193",
    "data-name": "Path 72193",
    d: "M5665.382,841.239s4.191-.558,3.951-3.351-1.928-4.644-2.65-3.82a14.143,14.143,0,0,0-1.3,1.789l-1.542,5.382Z",
    transform: "translate(-4632.766 -408.764)",
    fill: "#e8887c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72194",
    "data-name": "Path 72194",
    d: "M5105.471,446.156s-.288,7.615-1.879,10-2.745,4.976-10.7,3.656c-5.13-.853-6.086-7.013-6.12-11.274a29.7,29.7,0,0,1,.242-4.11s1.253-4.772,2.554-5.432c.013-.006.025-.013.04-.019,1.477-.684,12.372-2.876,15.331,2.1a27.539,27.539,0,0,1,.529,5.078",
    transform: "translate(-4071.5 -23.641)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72195",
    "data-name": "Path 72195",
    d: "M5105.326,484.912c-9.193,2.571-16.375-5.129-16.375-5.129-1.013,1.208-1.9,5.412-2.176,6.865a29.663,29.663,0,0,1,.241-4.11s1.253-4.772,2.554-5.432c.013-.006.025-.013.04-.019Z",
    transform: "translate(-4071.499 -61.75)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72196",
    "data-name": "Path 72196",
    d: "M5136.938,359.206c-10.307,2.791-17.252-6.746-17.252-6.746s-3.569-1.434,2.188-4.071c.2-.027.4-.054.6-.077l.2-.023a41.506,41.506,0,0,1,4.374-.276c1.1-.008,2.188.023,3.25.1,1.126.073,2.227.2,3.292.368a9.074,9.074,0,0,1,4.27,4.477c.862,2.894-.916,6.248-.916,6.248",
    transform: "translate(-4102.446 63.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72197",
    "data-name": "Path 72197",
    d: "M4999.973,256.8v4.738c-8.241-.272-17.287-10.238-17.287-10.238-2.223.322-5.489,4.826-7.011,6.992-.035-.548-.192-4.385,1.771-5.93,2.112-1.667,10.1-7.44,20.576-.433a4.007,4.007,0,0,1,1.652,2.507,5.256,5.256,0,0,1,.3,2.365",
    transform: "translate(-3963.425 160.541)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72198",
    "data-name": "Path 72198",
    d: "M5747.537,838.918l-.081-.012c0-1.28-.021-2.264-.043-2.8Z",
    transform: "translate(-4714.05 -410.936)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72199",
    "data-name": "Path 72199",
    d: "M5126.139,929.952a3.28,3.28,0,1,0,3.279-3.178,3.229,3.229,0,0,0-3.279,3.178",
    transform: "translate(-4109.786 -499.123)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72200",
    "data-name": "Path 72200",
    d: "M5473.185,929.952a3.178,3.178,0,1,0,3.178-3.178,3.178,3.178,0,0,0-3.178,3.178",
    transform: "translate(-4447.33 -499.123)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72206",
    "data-name": "Path 72206",
    d: "M5528.718,1951.289a3.7,3.7,0,0,1-3.213-1.913c-3.1-4.705-2.337-16.721.466-20.413,3.526-4.646,8.594,1.146,8.594,1.146s5.278,9.94,5.731,11.778-5,9.252-11.578,9.4",
    transform: "translate(-4496.266 -1472.117)",
    fill: "#ad825a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72208",
    "data-name": "Path 72208",
    d: "M5020.935,1381.453c-.468,1.523-2.6.872-3.928.872h-4.963l-5.174-.038H5001.9c-1.324,0-3.461.651-3.93-.873a9.461,9.461,0,0,1,.125-3.625s0,0,0,0c.2-1.2.46-2.367.589-3.084.183-1.038.4-2.066.653-3.079v0c.249-.994.529-1.976.839-2.938.071-.218.142-.437.215-.658.029-.087.057-.176.086-.264,0-.007,0-.015.007-.023.035-.1.068-.211.1-.317s.068-.218.1-.327c.026-.089.052-.177.075-.266.008-.023.013-.045.021-.068.025-.093.049-.184.073-.278l.021-.083c.021-.084.041-.167.06-.251a.062.062,0,0,1,0-.016,7.608,7.608,0,0,0,.208-2.141c-.122-2.144-1.352-3.867-1.833-5.916-.6-2.537,0-5.274.591-7.812a25.1,25.1,0,0,1,2.233-6.684c1.115-1.95,2.821-3.47,4.641-3.146l5.689-.084c1.818-.324,3.184,1.32,4.3,3.267A25.141,25.141,0,0,1,5019,1350.3c.6,2.54,1.193,5.275.594,7.813-.485,2.049-1.715,3.774-1.835,5.916a8.372,8.372,0,0,0,.331,2.639c.023.087.047.174.071.26.013.047.026.092.039.136.007.022.013.044.021.065l.039.134c.11.365.229.727.348,1.086l.078.24c.015.043.028.087.042.131q.24.739.452,1.5s0,0,0,0,0,.006,0,.007q.377,1.33.676,2.693a.106.106,0,0,0,0,.012q.2.9.358,1.809c.275,1.548,1.179,5.2.711,6.713",
    transform: "translate(-3985.003 -901.334)",
    fill: "#26a7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72209",
    "data-name": "Path 72209",
    d: "M5256.079,1246.07c-5.167,4.592-8.29,1.748-9.521.2l2.663-1.218v-1.914a25.938,25.938,0,0,0,3.91.147l-.013.733.016,1.033.416.143Z",
    transform: "translate(-4226.908 -806.826)",
    fill: "#26a7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72210",
    "data-name": "Path 72210",
    d: "M4965.381,2512.683H4938.7a96.968,96.968,0,0,1,1.818-22.482s0,0,0,0a57.108,57.108,0,0,1,1.557-6.165h19.8s.157.449.405,1.3a.082.082,0,0,0,0,.012,89.422,89.422,0,0,1,3.093,27.34",
    transform: "translate(-3927.426 -2013.746)",
    fill: "#d0dfee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72211",
    "data-name": "Path 72211",
    d: "M5468.9,3530.377c-.129.965-.209,1.819-.253,2.6h-6.728c-.222-1.343-.385-2.241-.385-2.241l-.113-.363Z",
    transform: "translate(-4435.885 -3031.441)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72212",
    "data-name": "Path 72212",
    d: "M5135.735,3530.377l-.115.363s-.162.9-.383,2.241c-.244,1.49-.558,3.527-.8,5.488-.431,3.523-1.428,18.894-1.152,22.113a39.833,39.833,0,0,0,.29,4.7l.72,4.882c-.757.6-3.623.67-4.13-.6a1.726,1.726,0,0,1-.068-.209l.786-4.073a12.609,12.609,0,0,0-.428-2.754c-.459-2.109-1.646-7.474-1.943-9.778-.01-.074-.019-.145-.026-.214l0-.032a60.663,60.663,0,0,1-.59-8.85c.224-4.864.818-7.018.615-10.67-.042-.785-.122-1.639-.251-2.6Z",
    transform: "translate(-4111.473 -3031.441)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72213",
    "data-name": "Path 72213",
    d: "M5141.891,3530.377h7.479l-.115.363s-.163.9-.384,2.241h-6.729c-.042-.785-.122-1.639-.251-2.6",
    transform: "translate(-4125.107 -3031.441)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72214",
    "data-name": "Path 72214",
    d: "M5180.422,4805.111a1.675,1.675,0,0,0-.554.905c-.221.694-1.042,5.745-1.042,5.745s-.126.888.221,1.012h5.145s.41-.1.442-.729-.994-5.891-1.136-6.329a1.2,1.2,0,0,0-.383-.6,39.636,39.636,0,0,1,.111,4.605c-.166.482-.414.482-.414.482h-1.752s-.8-.19-.854-.827.217-4.261.217-4.261",
    transform: "translate(-4161.01 -4271.273)",
    fill: "#883149"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72215",
    "data-name": "Path 72215",
    d: "M4877.16,1344.626l-4.292,10.447-1.852,8.617-.209.687-4.886-1.168s.32-2.779,1.784-9.171,9.456-9.411,9.456-9.411",
    transform: "translate(-3856.693 -905.535)",
    fill: "#26a7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72216",
    "data-name": "Path 72216",
    d: "M5461.4,3530.377l.114.363s.163.9.384,2.241c.244,1.49.558,3.527.8,5.488.431,3.523,1.427,18.894,1.152,22.113a39.8,39.8,0,0,1-.291,4.7l-.719,4.882c.757.6,3.623.67,4.13-.6a2.027,2.027,0,0,0,.068-.209l-.786-4.073a12.581,12.581,0,0,1,.427-2.754c.46-2.109,1.646-7.474,1.943-9.778.011-.074.019-.145.026-.214,0-.01,0-.022,0-.032a60.6,60.6,0,0,0,.591-8.85c-.224-4.864-.818-7.018-.615-10.67.042-.785.122-1.639.252-2.6Z",
    transform: "translate(-4435.863 -3031.441)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72217",
    "data-name": "Path 72217",
    d: "M5468.874,3530.377H5461.4l.114.363s.163.9.384,2.241h6.729c.042-.785.122-1.639.252-2.6",
    transform: "translate(-4435.863 -3031.441)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72218",
    "data-name": "Path 72218",
    d: "M5488.872,4805.111a1.672,1.672,0,0,1,.554.905c.221.694,1.042,5.745,1.042,5.745s.126.888-.221,1.012H5485.1s-.411-.1-.442-.729.994-5.891,1.136-6.329a1.2,1.2,0,0,1,.384-.6,39.614,39.614,0,0,0-.112,4.605c.167.482.415.482.415.482h1.752s.8-.19.854-.827-.217-4.261-.217-4.261",
    transform: "translate(-4458.49 -4271.273)",
    fill: "#883149"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72219",
    "data-name": "Path 72219",
    d: "M5599.969,2474.464a3.7,3.7,0,0,1-3.214-1.914c3.594-.816,7.166-1.862,9.061-3.079,4.707-3.026,5.731-4.411,5.731-4.411.454,1.839-5,9.252-11.578,9.4",
    transform: "translate(-4567.517 -1995.293)",
    fill: "#764a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72220",
    "data-name": "Path 72220",
    d: "M5577,1344.626l4.293,10.447,1.852,8.617.208.687,4.886-1.168s-.32-2.779-1.784-9.171-9.456-9.411-9.456-9.411",
    transform: "translate(-4548.299 -905.535)",
    fill: "#26a7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72221",
    "data-name": "Path 72221",
    d: "M5061.245,1717.667a8.371,8.371,0,0,0,.332,2.639c.185.7.421,1.379.638,2.052q.24.739.452,1.5c-.12-.264-2.079-4.509-3.961-5.4a2.517,2.517,0,0,0-.446-.151.009.009,0,0,0-.006,0h0a9.875,9.875,0,0,0-1.755-.217,76.609,76.609,0,0,0-8.986.369.008.008,0,0,1-.005,0,1.382,1.382,0,0,0-.419.166s0,0,0,0c-.759.417-2.429,1.84-4.255,6.633.249-.994.529-1.977.838-2.938.271-.836.567-1.683.762-2.552a7.7,7.7,0,0,0,.208-2.141c-.123-2.144-1.352-3.867-1.834-5.916-.6-2.537,0-5.274.592-7.813,0,0-1.159,9.514,2.46,10.452h14.393s3.411-2.017,2.241-10.414c.6,2.54,1.193,5.275.594,7.813-.486,2.049-1.715,3.774-1.836,5.916",
    transform: "translate(-4028.488 -1254.973)",
    fill: "#0b3454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72222",
    "data-name": "Path 72222",
    d: "M4962.287,2229.239a.106.106,0,0,1,0-.012q-.3-1.362-.676-2.693a.039.039,0,0,0,0-.007s0,0,0,0c-.141-.5-.292-1-.452-1.5-.217-.673-.454-1.356-.638-2.052a5.175,5.175,0,0,0-3.318-2,.009.009,0,0,0-.006,0h0c-.451-.051-1.054-.132-1.756-.217a76.6,76.6,0,0,0-8.985.369.009.009,0,0,1-.006,0l-.418.166s0,0,0,0c-1.173.465-2.037.85-2.655,1.142-.195.869-.491,1.716-.762,2.552-.309.962-.59,1.944-.838,2.938h0q-.377,1.52-.654,3.08c-.128.716-.389,1.885-.589,3.084,0,0,0,0,0,0a96.969,96.969,0,0,0-1.818,22.482h26.677a89.419,89.419,0,0,0-3.093-27.34",
    transform: "translate(-3927.424 -1757.643)",
    fill: "#26a7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72223",
    "data-name": "Path 72223",
    d: "M5265.567,1333.081l-3.551,3.249s-1.677-4.726.262-6.611Z",
    transform: "translate(-4241.288 -891.035)",
    fill: "#0b3454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72224",
    "data-name": "Path 72224",
    d: "M5418.923,1330.078s1.65,2.05.183,6.548l-3.479-3.2Z",
    transform: "translate(-4391.348 -891.385)",
    fill: "#0b3454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72225",
    "data-name": "Path 72225",
    d: "M5279.512,1298.772a13.8,13.8,0,0,1-.52,3.145l-2.175-1.7-1.241-.969-1.3,1.01-2.12,1.655a13.4,13.4,0,0,1-.526-3.386,6.613,6.613,0,0,1,.106-1.241c.007-.031.013-.061.02-.092,0-.009,0-.017.006-.025a3.609,3.609,0,0,1,.519-1.28,2.159,2.159,0,0,1,1.279-.952l.014,0,.012.015.031.041,1,1.325.015,0a1.068,1.068,0,0,0,.061.1l.08.109a1.055,1.055,0,0,0,1.6,0l1.147-1.522.051-.067h.007l.064.016a2.229,2.229,0,0,1,1.223.94,3.461,3.461,0,0,1,.461,1.041c.02.074.039.151.058.231.01.047.02.095.029.144a6.723,6.723,0,0,1,.1,1.462",
    transform: "translate(-4251.297 -857.207)",
    fill: "#0b3454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72226",
    "data-name": "Path 72226",
    d: "M5348.034,1244.015l.01.6-1.147,1.521a1.054,1.054,0,0,1-1.6,0l-.08-.109a.964.964,0,0,1-.061-.1l-.015,0-1-1.325v-1.474a25.8,25.8,0,0,0,3.909.147Z",
    transform: "translate(-4321.817 -806.822)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72227",
    "data-name": "Path 72227",
    d: "M5063.768,1703.9s-.379,8.039,2.841,8.323,12.594,0,12.594,0,4.146.474,3.66-8.285c0,0,2.113,6.956-2.241,10.414h-14.393s-3.738,1.489-2.46-10.452",
    transform: "translate(-4048.863 -1254.973)",
    fill: "#0b3454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72228",
    "data-name": "Path 72228",
    d: "M4720.672,1711.353l-2.118-6.052s-8.218.908-10.892,2.522l7.009,12.067,7.9-3.8Z",
    transform: "translate(-3702.768 -1256.334)",
    fill: "#eb9350"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72229",
    "data-name": "Path 72229",
    d: "M4822.853,1767.947l8.809-1.772-3.714-14.827-11.65,3.177Z",
    transform: "translate(-3808.428 -1301.121)",
    fill: "#65363f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72230",
    "data-name": "Path 72230",
    d: "M5127.481,1820.986c0,.7.589.553.1,1.348a3.148,3.148,0,0,1-.56.7c-.579.535-1.635,1.07-4.1,1.71,0,0-1.509-1.538-1.374-2.412a3.219,3.219,0,0,1,.834-2.135c.932-1.18,1.569-2.055,1.913-2.055s.245.766.245.766a19.988,19.988,0,0,1,2.733-1.763,1.231,1.231,0,0,1,.8-.183c.638.262-1.276,1.705-1.276,2.186s.687,1.137.687,1.837",
    transform: "translate(-4105.309 -1364.918)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72231",
    "data-name": "Path 72231",
    d: "M4791.844,1981.657s.168.323-2.628.979-5.446,1.312-6.525,2.273.442,2.885,3.925,2.361a19.61,19.61,0,0,0,6.476-2.361s1.723-1.958-1.248-3.252",
    transform: "translate(-3775.409 -1525.125)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72232",
    "data-name": "Path 72232",
    d: "M5733.63,1915.232s5.4,4.716,4.821,6.761-3.478,1.858-5.445.23-1.967-5.58-1.967-5.58Z",
    transform: "translate(-4698.125 -1460.518)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72233",
    "data-name": "Path 72233",
    d: "M5622.724,1748.9a2.151,2.151,0,0,0,.473.573.3.3,0,0,1,.026.024c.195.2.162.709.171,1.258a2.391,2.391,0,0,0,.305,1.353,4.016,4.016,0,0,0,1.421,1.154,2.01,2.01,0,0,0,2.458-1.391c.769-1.924.829-4.826.236-5.151a2.274,2.274,0,0,0-.459-.166c-1.02-.28-3.111-.52-3.655-.1-.029.022-.058.043-.086.061a.99.99,0,0,1-.445.162c-.328.037-.546-.061-.742.547a2.122,2.122,0,0,0,.3,1.677",
    transform: "translate(-4592.416 -1296.139)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72234",
    "data-name": "Path 72234",
    d: "M5658.16,1746.547c-.051,1.316-.264,4.13-1.169,4.311a4.849,4.849,0,0,1-2.792-.11c-.009-.549.023-1.061-.171-1.258.1-.821.261-2.03.391-2.982.027-.019.057-.039.085-.061a.807.807,0,0,1,.257-.123,7.513,7.513,0,0,1,2.94.114c.168.034.323.071.459.109",
    transform: "translate(-4623.223 -1296.133)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72235",
    "data-name": "Path 72235",
    d: "M5622.724,1764.9a2.085,2.085,0,0,0,.514-1.007,2.017,2.017,0,0,0-.069-1.217c-.328.038-.546-.061-.742.547a2.122,2.122,0,0,0,.3,1.677",
    transform: "translate(-4592.416 -1312.141)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72236",
    "data-name": "Path 72236",
    d: "M5745.231,2003.214a5.36,5.36,0,0,1-2.905,2.449l-2.813-12.457a3.014,3.014,0,0,0,1.2-.349,16.445,16.445,0,0,1,2.172,3.924c.325.844,1.3,3.39,2.343,6.433",
    transform: "translate(-4706.365 -1536.018)",
    fill: "#764a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72237",
    "data-name": "Path 72237",
    d: "M5570.022,1351.063a7.514,7.514,0,0,0-2.94-.115c-.974-8.231-3.2-11.234-3.2-11.234a5.388,5.388,0,0,1,3.86,1.839c1.851,2.567,2.213,7.861,2.282,9.51",
    transform: "translate(-4535.541 -900.758)",
    fill: "#764a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72238",
    "data-name": "Path 72238",
    d: "M5267.468,1820.986c0,.7.589.553.1,1.348a3.142,3.142,0,0,1-.559.7c-.3-.25-.372-.687-.646-.926-.475-.416-.3-.66-.728-1.669s-.007-1.379.9-2.186c.681-.6.738-.965.725-1.108a1.227,1.227,0,0,1,.8-.183c.638.262-1.275,1.705-1.275,2.186s.687,1.137.687,1.837",
    transform: "translate(-4245.296 -1364.918)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72239",
    "data-name": "Path 72239",
    d: "M3660.511,4533.454c0,.144,1.488,10.27,1.488,10.27h5.231l-1.2-7.87Z",
    transform: "translate(-2684.287 -4007.055)",
    fill: "#353c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19043",
    "data-name": "Rectangle 19043",
    width: 5.474,
    height: 10.275,
    transform: "translate(992.521 526.4)",
    fill: "#353c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72240",
    "data-name": "Path 72240",
    d: "M3546.037,2722.74h-6.774s-1.441-13.631-4.18-23.137a105.249,105.249,0,0,1-3.014-18.749c-.039-.47-.073-.913-.1-1.323-.054-.73-.095-1.359-.125-1.864q-.015-.242-.026-.444c-.034-.6-.048-.937-.048-.937s-.069.4-.189,1.122q-.03.178-.063.381c-.053.323-.113.692-.179,1.1-.1.615-.211,1.324-.331,2.109-.363,2.378-.8,5.456-1.2,8.756,0,0,0,0,0,.006-.146,1.212-.286,2.455-.415,3.7a.04.04,0,0,0,0,.011c-.323,3.144-.57,6.328-.647,9.173a132.392,132.392,0,0,0,1.3,20.985h-6.631s-3.683-22.594-3.539-31.3c.009-.57.036-1.08.079-1.521.205-2.04.287-4.717.3-7.5v-.026c.005-1.251,0-2.525-.021-3.773-.017-1.167-.041-2.31-.071-3.392-.014-.512-.028-1.01-.043-1.489-.11-3.5-.246-6.056-.246-6.056h22.714c-.049.182-.131,2.624-.156,6.056q-.006.743-.007,1.544c0,1.089,0,2.25.015,3.447.064,6.1.347,13.177,1.157,16.932a111.566,111.566,0,0,1,2.451,26.186",
    transform: "translate(-2547.491 -2193.234)",
    fill: "#314d73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72241",
    "data-name": "Path 72241",
    d: "M4175.747,4754.848h0a2.031,2.031,0,0,0,.825-1.129c.022-.134.04-.31.074-.506a2.239,2.239,0,0,1,2.288-2c2.252-.235,3.766.1,4.3,1.109a4.1,4.1,0,0,1,.363,1.2c.116.582.229,1.083.829,1.326a3.956,3.956,0,0,1,.094.452l.393,3.592h-9.654s.3-2.7.484-4.043",
    transform: "translate(-3184.944 -4218.783)",
    fill: "#dee8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72242",
    "data-name": "Path 72242",
    d: "M3348.575,4750.894c.228-.133.444-.271.649-.411a3.855,3.855,0,0,0,1.271-2.313c.3-1.076,1.791-.986,1.791-.986l.056,0c2.177.177,2.546,1.547,2.546,1.547.775,1.439.885,1.383,2.325,1.217s1.441-1.383,2.16-.275.831,4.262.831,4.262a1.015,1.015,0,0,1,.554.664v1.052a.649.649,0,0,1-.61.775h-5.039a.627.627,0,0,1-.663-.775c-.887-.443-2.16.775-2.16.775h-7.142c-1.219-.11-1.383-.664-1.383-.664V4754c.11-3.766,2.158-1.552,4.816-3.1",
    transform: "translate(-2376.208 -4214.93)",
    fill: "#dee8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72243",
    "data-name": "Path 72243",
    d: "M3550.524,4845.194s2.432.708,2.445,1.2c0,0-.122.3-.357.235a9.03,9.03,0,0,0-2.5-.954.427.427,0,0,1,.408-.477",
    transform: "translate(-2576.913 -4310.258)",
    fill: "#c5d6ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72244",
    "data-name": "Path 72244",
    d: "M3513.061,4874.824a5.492,5.492,0,0,1,1.912,1.053.415.415,0,0,1-.476.353,9.2,9.2,0,0,0-1.98-1.084.54.54,0,0,1,.545-.321",
    transform: "translate(-2540.344 -4339.074)",
    fill: "#c5d6ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72245",
    "data-name": "Path 72245",
    d: "M3464.378,4894.649s1.466.832,1.466,1.118a.793.793,0,0,1-.687.2,4.444,4.444,0,0,0-1.54-1.119.732.732,0,0,1,.761-.2",
    transform: "translate(-2492.784 -4358.324)",
    fill: "#c5d6ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72246",
    "data-name": "Path 72246",
    d: "M3660.156,4908.908l3.117,2.526,1.066-.317-3.279-2.579Z",
    transform: "translate(-2683.941 -4371.867)",
    fill: "#a9c2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72247",
    "data-name": "Path 72247",
    d: "M3578.375,4941.882l2.891,2.342,1.058-.315-3.008-2.412Z",
    transform: "translate(-2604.399 -4403.926)",
    fill: "#a9c2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72248",
    "data-name": "Path 72248",
    d: "M3493.372,4975.362l2.981,2.054.831-.247-2.78-2.229Z",
    transform: "translate(-2521.724 -4436.451)",
    fill: "#a9c2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72249",
    "data-name": "Path 72249",
    d: "M3360.148,4992.973h-5.039a.626.626,0,0,1-.663-.774c-.887-.444-2.16.774-2.16.774h-7.143c-1.219-.11-1.383-.664-1.383-.664v-.982c2.058.053,4.629.121,5.481.153,1.5.054,3.376-.777,4.705-1a57.678,57.678,0,0,1,6.257,0,1.016,1.016,0,0,1,.554.665v1.052a.648.648,0,0,1-.61.774",
    transform: "translate(-2376.209 -4451.473)",
    fill: "#a9c2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72250",
    "data-name": "Path 72250",
    d: "M4171.25,5023.541h-8.93a.8.8,0,0,1-.792-.792v-.144a.8.8,0,0,1,.792-.792h8.93a.8.8,0,0,1,.792.792v.144a.8.8,0,0,1-.792.792",
    transform: "translate(-3171.586 -4482.039)",
    fill: "#a9c2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72251",
    "data-name": "Path 72251",
    d: "M4237.335,4852.63a.8.8,0,0,1,.056.073.23.23,0,0,1,.055.193.177.177,0,0,1-.191.1.549.549,0,0,1-.214-.092,5.2,5.2,0,0,0-3.3-.665,21.252,21.252,0,0,0-2.826.76.411.411,0,0,1-.192.02.145.145,0,0,1-.122-.133c0-.068.066-.115.124-.151a6.952,6.952,0,0,1,3.6-1.051,6.128,6.128,0,0,1,2.189.416,1.982,1.982,0,0,1,.825.526",
    transform: "translate(-3238.766 -4316.574)",
    fill: "#c5d6ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72252",
    "data-name": "Path 72252",
    d: "M4234.208,4885.022c.02.023.039.048.057.074a.232.232,0,0,1,.055.192.175.175,0,0,1-.191.1.546.546,0,0,1-.214-.092,5.2,5.2,0,0,0-3.3-.665,21.306,21.306,0,0,0-2.826.76.413.413,0,0,1-.192.02.145.145,0,0,1-.122-.133c0-.068.066-.115.124-.151a6.945,6.945,0,0,1,3.6-1.05,6.138,6.138,0,0,1,2.189.416,1.98,1.98,0,0,1,.825.525",
    transform: "translate(-3235.723 -4348.08)",
    fill: "#c5d6ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72253",
    "data-name": "Path 72253",
    d: "M3456.448,1126.283a6.188,6.188,0,0,1-.793,1.777,2.491,2.491,0,0,1-.981.9l-.039.023c-.161.091-.312.163-.433.217-.162.073-.269.109-.269.109v-.686a31.365,31.365,0,0,1-4.011.73c-1.262.152-2.546.244-3.821.289a69.26,69.26,0,0,1-8.879-.309c-2.278-.217-4.121-.488-5.186-.661-.3-.049-.541-.091-.71-.121v0l-.026.505a3.143,3.143,0,0,1-.735-.732,5.642,5.642,0,0,1-1.048-3.269v0l1.6-9.943.148-.918,1.725-10.706v0l-.074-.561-.051-.39-.734-5.553-.309-2.332a7.89,7.89,0,0,1,2.965-2.323h0l2.225-.841.682-.258.257-.1.825-.311,2.288-.864.043-1.882,0-.16.071-3.015-.051-.073.006-.443,2.463.221,2.462-.221.005.443.067.006-.051,3.129,0,.31-.027,1.653,1.076.406,1.145.433.19.071.758.286.284.108.659.249,2.249.85a13.565,13.565,0,0,1,2.79,2.614l0,1.045-.865,6.549-.057.434-.068.517,1.234,7.667v0l1.083,9.7v.007a53.455,53.455,0,0,1-.08,5.425",
    transform: "translate(-2459.616 -652.418)",
    fill: "#f2e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72254",
    "data-name": "Path 72254",
    d: "M3777.459,1090.825c-.547,2.686-2.507,4.673-4.841,4.673s-4.3-1.995-4.843-4.687l2.288-.864.047-2.043.07-3.015-.051-.073.005-.443,2.463.221,2.462-.221.005.443.067.006-.051,3.129-.032,1.963,1.076.406,1.145.433Z",
    transform: "translate(-2788.613 -652.408)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72255",
    "data-name": "Path 72255",
    d: "M3857.643,1089.479c-.04-.014-.066-.022-.08-.026l-.009,0-1.478,2.666a1.1,1.1,0,0,1-1.979,0l-.1-.182c-.028-.056-.052-.114-.075-.174l-.018.008-1.27-2.293-.015-.024-.018.006v-4.317l5-.609.013,1.509Z",
    transform: "translate(-2871.118 -652.561)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72256",
    "data-name": "Path 72256",
    d: "M4181.082,701.128s.7.713,2.385-.54,3.024-2.894,1.771-5.27-6.566,2.3-6.566,2.3Z",
    transform: "translate(-3188.26 -273.35)",
    fill: "#e8887c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72257",
    "data-name": "Path 72257",
    d: "M3446.44,715.657s-.7.713-2.385-.54-3.024-2.894-1.771-5.27,6.566,2.3,6.566,2.3Z",
    transform: "translate(-2471.557 -287.48)",
    fill: "#e8887c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72258",
    "data-name": "Path 72258",
    d: "M3571.485,229.213s.216,5.227,2.462,6.739,4.493,2.938,7.733,2.765,6.912-1.2,7.992-4.745a37.306,37.306,0,0,0,1.339-7.221s1.426-4.752.821-8.122-3.413-5.616-8.251-5.875-9.331-.173-11.491,2.376-.6,14.083-.6,14.083",
    transform: "translate(-2597.171 195.441)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72261",
    "data-name": "Path 72261",
    d: "M3490.183,13.531c-.1,2.682-.961,5.563-3.173,7.086q-.006-.926-.011-1.85a24.594,24.594,0,0,1-9.8-3,6.722,6.722,0,0,0,.546,2.606,9.97,9.97,0,0,1-6.039-3.728,6.221,6.221,0,0,0,.25,2.851,5.206,5.206,0,0,1-4.129-.991,23.676,23.676,0,0,1-.067,5.439,11.516,11.516,0,0,1-3.587-6.91,15.255,15.255,0,0,1,.056-4.68q.042-.264.092-.528a9.2,9.2,0,0,1,.653-2.476c.166-.311.362-.625.565-.933.158-.238.322-.472.48-.7a13.621,13.621,0,0,1,9.318-5.612,14.14,14.14,0,0,1,8.194,1.534,12.409,12.409,0,0,1,5.205,4.955c.119.218.228.438.331.663a12.2,12.2,0,0,1,.878,2.817,14.557,14.557,0,0,1,.207,1.61,16.454,16.454,0,0,1,.03,1.842",
    transform: "translate(-2493.174 402.264)",
    fill: "#62413e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72262",
    "data-name": "Path 72262",
    d: "M3480.715,237.834s-3.009,1.7-5.792.334a4.2,4.2,0,0,0-2.551-.248,6.353,6.353,0,0,1-.675.021c.028-.176.059-.353.092-.528a9.224,9.224,0,0,1,.653-2.476c.167-.311.362-.625.566-.933,1.71.438,3.232,1.482,3.323,2.336.164,1.581,4.384,1.493,4.384,1.493",
    transform: "translate(-2500.644 174.678)",
    fill: "#6e4d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72263",
    "data-name": "Path 72263",
    d: "M3687.6,190.175s-2.283,4.972.213,9.411h.409s-2.415-2.867-.622-9.411",
    transform: "translate(-2709.708 217.307)",
    fill: "#542d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72264",
    "data-name": "Path 72264",
    d: "M3909.614,246.947c-.7.012-1.629,0-2.037-.039-1.865-.152-3.505-1.229-5.173-2.081a10.053,10.053,0,0,0-2.733-.992,5.35,5.35,0,0,0-1.443-.079c-1.038.095-1.92.691-2.94.853a7.463,7.463,0,0,1,6.95-2.614c1.57.275,3.075,1.062,4.662.931a11.9,11.9,0,0,0,1.63-.407,12.176,12.176,0,0,1,.878,2.817,14.5,14.5,0,0,1,.207,1.61",
    transform: "translate(-2912.635 167.006)",
    fill: "#6e4d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72265",
    "data-name": "Path 72265",
    d: "M4339.621,389.573s2.105,4.118.569,7.9c0,0,.768-4.765-.569-7.9",
    transform: "translate(-3344.803 23.369)",
    fill: "#542d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72266",
    "data-name": "Path 72266",
    d: "M3858.183,194.364s-.854,7.967,2.447,10.5l-.4-.74s-1.963-2.276-2.048-9.759",
    transform: "translate(-2876.449 213.232)",
    fill: "#542d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72267",
    "data-name": "Path 72267",
    d: "M4159.324,145.652s4.481,4.878,4.054,11.06a25.151,25.151,0,0,0-4.054-11.06",
    transform: "translate(-3169.442 260.611)",
    fill: "#54322e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72268",
    "data-name": "Path 72268",
    d: "M3594.255,68.047c-1.931.814-3.968,1.713-5.15,3.444a7.808,7.808,0,0,0-1.144,4.655,43.693,43.693,0,0,0,.628,4.831,14.744,14.744,0,0,1,.651-7.631,10.639,10.639,0,0,1,5.015-5.3",
    transform: "translate(-2613.718 336.092)",
    fill: "#54322e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72269",
    "data-name": "Path 72269",
    d: "M3776.593,145.652s-3.344,6.523,1.293,11.413c0,0-3-5.822-1.293-11.413",
    transform: "translate(-2796.056 260.611)",
    fill: "#54322e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72270",
    "data-name": "Path 72270",
    d: "M4008.124,97.331a24.716,24.716,0,0,1,4.14,11.267s.256-7-4.14-11.267",
    transform: "translate(-3022.382 307.609)",
    fill: "#54322e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72271",
    "data-name": "Path 72271",
    d: "M3957.232,368.535s.558,5.836,3.437,7.287a16.362,16.362,0,0,1-3.437-7.287",
    transform: "translate(-2972.884 43.83)",
    fill: "#542d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72272",
    "data-name": "Path 72272",
    d: "M4058.552,277.737s1.544,8.536,3.884,10.581c0,0-3.073-6.186-3.884-10.581",
    transform: "translate(-3071.43 132.143)",
    fill: "#542d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72273",
    "data-name": "Path 72273",
    d: "M4067.9,501.614s.347,3.175,1.945,4.241a23.91,23.91,0,0,1-1.945-4.241",
    transform: "translate(-3080.525 -85.605)",
    fill: "#542d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72274",
    "data-name": "Path 72274",
    d: "M3649.463,821.662a3.5,3.5,0,1,0,3.494-3.292,3.4,3.4,0,0,0-3.494,3.292",
    transform: "translate(-2673.541 -393.688)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72375",
    "data-name": "Path 72375",
    d: "M168.056,0V139.225H0Z",
    transform: "translate(876 402.275)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72277",
    "data-name": "Path 72277",
    d: "M4019.316,821.662a3.388,3.388,0,1,0,3.387-3.292,3.341,3.341,0,0,0-3.387,3.292",
    transform: "translate(-3033.268 -393.688)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72280",
    "data-name": "Path 72280",
    d: "M3199.5,1266.027s-5.749,29.124-9.549,29.166c-.1,0-.2,0-.306-.011a4.2,4.2,0,0,1-1.693-.528c-2.277-1.239-4.092-4.344-4.789-6.423l0-.007a5.759,5.759,0,0,1-.3-1.276c0-.014,0-.029,0-.042a1.688,1.688,0,0,1,.011-.3c.317-2.795,5.987-14.3,8.31-16.264,2.42-2.042,8.321-4.312,8.321-4.312",
    transform: "translate(-2219.705 -829.088)",
    fill: "#26a7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72281",
    "data-name": "Path 72281",
    d: "M3189.687,1932.968l-.045,1.956a4.2,4.2,0,0,1-1.693-.528c-2.277-1.239-4.092-4.344-4.79-6.423l0-.007a7.667,7.667,0,0,1-.3-1.276c0-.014,0-.029,0-.042a1.663,1.663,0,0,1,.011-.3c1.963-.773,5.511-2.567,5.511-2.567-.192.933.808,4.451.808,4.451Z",
    transform: "translate(-2219.705 -1468.83)",
    fill: "#1985b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72282",
    "data-name": "Path 72282",
    d: "M3386.424,2093.388l-1.759,7.788-.125-.333c-1.435-.34-1.385-3.734-1.331-4.814a18.057,18.057,0,0,1,1.848-3.037,3.416,3.416,0,0,0,1.367.4",
    transform: "translate(-2414.557 -1633.41)",
    fill: "#3f3f44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72283",
    "data-name": "Path 72283",
    d: "M3396.787,1219.135c-.057.586-.309,2.068-.643,4.135-.7,4.336-1.771,11.245-2.181,17.854-.453,7.3-.651,12.695-.723,14.95-.025.759-.034,1.163-.034,1.163a1.269,1.269,0,0,1-1.067.752,24.367,24.367,0,0,1-4.41-.919c-.238-.065-.478-.132-.713-.2q-.389-.112-.762-.227a20.565,20.565,0,0,1-2.083-.739,1.4,1.4,0,0,1-.193-1.046l4.629-23.617,1.815-9.257,2.86-1.361s.144-.522.361-1.176a7.472,7.472,0,0,1,1.152-2.455,3.893,3.893,0,0,1,1.992-.681s0,.026.012.079a12.421,12.421,0,0,1-.012,2.745",
    transform: "translate(-2415.307 -780.732)",
    fill: "#26a7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72284",
    "data-name": "Path 72284",
    d: "M3345.229,1874.148a2.534,2.534,0,0,1-1.109-2.31c0-1.724.679-6.066,1.365-6.635l2.064,3.465-.491,2.772Z",
    transform: "translate(-2376.558 -1411.859)",
    fill: "#1985b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72285",
    "data-name": "Path 72285",
    d: "M3397.688,1815.92a2.462,2.462,0,0,1-.537.651.262.262,0,0,0-.03.027c-.221.224-.184.805-.194,1.429a2.715,2.715,0,0,1-.347,1.536,4.556,4.556,0,0,1-1.614,1.311,2.283,2.283,0,0,1-2.791-1.58c-.874-2.186-.941-5.481-.268-5.851a2.611,2.611,0,0,1,.521-.189c1.159-.318,3.534-.591,4.152-.114q.05.038.1.07a1.129,1.129,0,0,0,.505.184c.372.043.621-.07.843.621a2.413,2.413,0,0,1-.338,1.9",
    transform: "translate(-2422.596 -1360.973)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72286",
    "data-name": "Path 72286",
    d: "M3595.959,1834.092a2.373,2.373,0,0,1-.584-1.143,2.283,2.283,0,0,1,.079-1.381c.373.042.621-.07.843.621a2.414,2.414,0,0,1-.338,1.9",
    transform: "translate(-2620.868 -1379.145)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72287",
    "data-name": "Path 72287",
    d: "M3727.979,1219.128c-.058.586-.309,2.068-.643,4.135a7.778,7.778,0,0,1-2.862-2.647s.832-3.025,1.513-3.631a3.893,3.893,0,0,1,1.992-.681,11.629,11.629,0,0,1,0,2.824",
    transform: "translate(-2746.498 -780.727)",
    fill: "#91939f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72288",
    "data-name": "Path 72288",
    d: "M3447.8,1303.3c-.109.333-.214.679-.315,1.034h0a80.034,80.034,0,0,0-2.046,11.329l1.133.955,2.145-.955a51.333,51.333,0,0,1,3.5-13.925l.387-.9,0-.012c-2.536.158-4.81,2.474-4.81,2.474",
    transform: "translate(-2475.1 -862.934)",
    fill: "#3f3f44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72289",
    "data-name": "Path 72289",
    d: "M3431.724,1816.6c-.221.224-.184.805-.194,1.429a5.509,5.509,0,0,1-3.171.125c-1.028-.206-1.27-3.4-1.327-4.9,1.159-.318,3.534-.591,4.152-.114q.05.038.1.07c.147,1.081.331,2.454.444,3.387",
    transform: "translate(-2457.199 -1360.973)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72290",
    "data-name": "Path 72290",
    d: "M3725.985,1573.324a.756.756,0,1,1-.757-.756.757.757,0,0,1,.757.756",
    transform: "translate(-2746.497 -1127.236)",
    fill: "#ead0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72291",
    "data-name": "Path 72291",
    d: "M3698.357,1815.912a.756.756,0,1,1-.756-.757.756.756,0,0,1,.756.757",
    transform: "translate(-2719.625 -1363.182)",
    fill: "#ead0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72292",
    "data-name": "Path 72292",
    d: "M3670.728,2039.33a.756.756,0,1,1-.757-.756.756.756,0,0,1,.757.756",
    transform: "translate(-2692.753 -1580.482)",
    fill: "#ead0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72293",
    "data-name": "Path 72293",
    d: "M3658.173,2262.75a.757.757,0,1,1-.757-.757.757.757,0,0,1,.757.757",
    transform: "translate(-2680.541 -1797.785)",
    fill: "#ead0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72294",
    "data-name": "Path 72294",
    d: "M3643.1,2486.17a.757.757,0,1,1-.756-.757.756.756,0,0,1,.756.757",
    transform: "translate(-2665.88 -2015.088)",
    fill: "#ead0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72295",
    "data-name": "Path 72295",
    d: "M3391.344,2666.854a20.4,20.4,0,0,1-3.933-.805,20.07,20.07,0,0,1-3.162-1.246l-.7-.471a4.516,4.516,0,0,1,.194-1.95,20.53,20.53,0,0,0,2.083.739q.372.115.762.227c.235.068.474.135.713.2a24.4,24.4,0,0,0,4.41.919s.034,2.051-.37,2.387",
    transform: "translate(-2414.882 -2187.213)",
    fill: "#1985b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72296",
    "data-name": "Path 72296",
    d: "M4097.083,1268.9s5.749,29.124,9.549,29.166c.1,0,.2,0,.306-.011a4.2,4.2,0,0,0,1.692-.528c2.277-1.239,4.092-4.344,4.79-6.423a.037.037,0,0,1,0-.007,5.716,5.716,0,0,0,.3-1.276c0-.014,0-.029,0-.042a1.713,1.713,0,0,0-.011-.3c-.317-2.795-5.986-14.3-8.31-16.264-2.42-2.042-8.321-4.312-8.321-4.312",
    transform: "translate(-3108.905 -831.879)",
    fill: "#26a7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72297",
    "data-name": "Path 72297",
    d: "M4455.331,1935.836l.045,1.956a4.2,4.2,0,0,0,1.693-.528c2.277-1.239,4.092-4.344,4.79-6.423l0-.007a7.612,7.612,0,0,0,.3-1.276c0-.014,0-.029,0-.042a1.711,1.711,0,0,0-.011-.3c-1.963-.773-5.511-2.566-5.511-2.566.193.933-.807,4.45-.807,4.45Z",
    transform: "translate(-3457.345 -1471.619)",
    fill: "#1985b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72298",
    "data-name": "Path 72298",
    d: "M4386.524,2096.257l1.758,7.788.126-.333c1.435-.34,1.384-3.734,1.331-4.814a18,18,0,0,0-1.848-3.037,3.412,3.412,0,0,1-1.367.4",
    transform: "translate(-3390.422 -1636.201)",
    fill: "#3f3f44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72299",
    "data-name": "Path 72299",
    d: "M4045.2,1258.759a31.672,31.672,0,0,1-4.047,1.3l-.039.01c-.237.063-.471.122-.7.18a17.194,17.194,0,0,1-3.18.6,1.247,1.247,0,0,1-.83-.4,1.212,1.212,0,0,1-.237-.356s-.01-.431-.036-1.241c-.073-2.3-.273-7.655-.72-14.872-.41-6.608-1.479-13.518-2.181-17.854-.334-2.067-.586-3.549-.643-4.135a13.036,13.036,0,0,1-.026-2.627c.014-.131.026-.2.026-.2a3.893,3.893,0,0,1,1.992.681,7.194,7.194,0,0,1,1.123,2.366c.233.7.39,1.265.39,1.265l2.861,1.361,1.808,9.223,4.636,23.651a1.406,1.406,0,0,1-.194,1.046",
    transform: "translate(-3046.1 -783.51)",
    fill: "#26a7df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72300",
    "data-name": "Path 72300",
    d: "M4420.818,1877.017a2.534,2.534,0,0,0,1.109-2.31c0-1.724-.679-6.065-1.365-6.635l-2.064,3.465.491,2.771Z",
    transform: "translate(-3421.521 -1414.648)",
    fill: "#1985b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72301",
    "data-name": "Path 72301",
    d: "M4253.885,1818.789a2.46,2.46,0,0,0,.537.651.266.266,0,0,1,.03.027c.221.224.184.8.194,1.429a2.718,2.718,0,0,0,.347,1.536,4.558,4.558,0,0,0,1.613,1.311,2.284,2.284,0,0,0,2.792-1.58c.874-2.186.941-5.48.268-5.85a2.585,2.585,0,0,0-.521-.189c-1.158-.318-3.534-.591-4.151-.114-.033.026-.066.049-.1.07a1.124,1.124,0,0,1-.505.184c-.373.043-.621-.07-.843.621a2.414,2.414,0,0,0,.338,1.9",
    transform: "translate(-3261.008 -1363.762)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72302",
    "data-name": "Path 72302",
    d: "M4253.885,1836.961a2.376,2.376,0,0,0,.584-1.143,2.291,2.291,0,0,0-.079-1.382c-.373.043-.621-.07-.843.621a2.414,2.414,0,0,0,.338,1.9",
    transform: "translate(-3261.008 -1381.934)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72303",
    "data-name": "Path 72303",
    d: "M4032.582,1222c.057.586.309,2.068.643,4.135a7.778,7.778,0,0,0,2.862-2.647s-.833-3.026-1.513-3.631a3.9,3.9,0,0,0-1.992-.681,11.6,11.6,0,0,0,0,2.824",
    transform: "translate(-3046.094 -783.518)",
    fill: "#91939f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72304",
    "data-name": "Path 72304",
    d: "M4185.307,1306.169c.109.333.214.679.315,1.034h0a80.115,80.115,0,0,1,2.046,11.329l-1.133.955-2.145-.955a51.311,51.311,0,0,0-3.5-13.925l-.386-.9,0-.012c2.535.158,4.81,2.474,4.81,2.474",
    transform: "translate(-3190.035 -865.725)",
    fill: "#3f3f44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72305",
    "data-name": "Path 72305",
    d: "M4289.443,1819.466c.221.224.184.8.194,1.429a5.509,5.509,0,0,0,3.171.125c1.028-.206,1.27-3.4,1.327-4.9-1.159-.318-3.534-.59-4.152-.114-.033.026-.066.049-.1.07-.147,1.081-.331,2.454-.444,3.387",
    transform: "translate(-3295.998 -1363.762)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72306",
    "data-name": "Path 72306",
    d: "M4108.138,1576.194a.757.757,0,1,0,.756-.757.756.756,0,0,0-.756.757",
    transform: "translate(-3119.658 -1130.027)",
    fill: "#ead0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72307",
    "data-name": "Path 72307",
    d: "M4135.767,1818.78a.756.756,0,1,0,.757-.757.756.756,0,0,0-.757.757",
    transform: "translate(-3146.53 -1365.971)",
    fill: "#ead0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72308",
    "data-name": "Path 72308",
    d: "M4163.4,2042.2a.756.756,0,1,0,.756-.756.757.757,0,0,0-.756.756",
    transform: "translate(-3173.402 -1583.273)",
    fill: "#ead0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72309",
    "data-name": "Path 72309",
    d: "M4175.95,2265.618a.756.756,0,1,0,.757-.756.757.757,0,0,0-.757.756",
    transform: "translate(-3185.613 -1800.574)",
    fill: "#ead0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72310",
    "data-name": "Path 72310",
    d: "M4191.024,2489.039a.757.757,0,1,0,.756-.757.756.756,0,0,0-.756.757",
    transform: "translate(-3200.274 -2017.879)",
    fill: "#ead0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72311",
    "data-name": "Path 72311",
    d: "M4213.283,2667.188l-.7.471a20.443,20.443,0,0,1-3.642,1.386,19.958,19.958,0,0,1-3.452.665c-.4-.336-.37-2.387-.37-2.387a17.2,17.2,0,0,0,3.18-.6c.23-.058.466-.117.7-.18l.039-.01a31.661,31.661,0,0,0,4.047-1.3,4.513,4.513,0,0,1,.193,1.949",
    transform: "translate(-3213.986 -2189.99)",
    fill: "#1985b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72312",
    "data-name": "Path 72312",
    d: "M3548,2728.3c-.011.708-.021,1.495-.028,2.341-8.353,1.665-17.954.634-22.312,0-.029-.929-.06-1.792-.09-2.559a20.4,20.4,0,0,0,3.933.805c.4-.336.37-2.387.37-2.387a1.256,1.256,0,0,0,.773-.338,69.324,69.324,0,0,0,8.879.309c1.275-.045,2.559-.136,3.821-.289a1.246,1.246,0,0,0,.83.4s-.034,2.051.37,2.387a19.951,19.951,0,0,0,3.453-.665",
    transform: "translate(-2553.045 -2249.24)",
    fill: "#223d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72313",
    "data-name": "Path 72313",
    d: "M592.766,1232.155a24.459,24.459,0,0,0-12.85.108v3.49h12.85Z",
    transform: "translate(311.962 -795.355)",
    fill: "#1d2435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72314",
    "data-name": "Path 72314",
    d: "M833.815,4533.449c0,.144-1.488,10.27-1.488,10.27H827.1l1.2-7.87Z",
    transform: "translate(71.549 -4007.049)",
    fill: "#08090a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19048",
    "data-name": "Rectangle 19048",
    width: 5.474,
    height: 10.275,
    transform: "translate(883.594 526.4)",
    fill: "#08090a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72315",
    "data-name": "Path 72315",
    d: "M281.768,2692.334c.143,8.708-3.539,31.3-3.539,31.3H271.6a132.348,132.348,0,0,0,1.3-20.985c-.076-2.844-.323-6.029-.646-9.172,0,0,0-.007,0-.011-.129-1.249-.269-2.492-.415-3.7a.017.017,0,0,1,0-.006c-.4-3.3-.838-6.378-1.2-8.756-.119-.785-.231-1.494-.33-2.109-.066-.411-.126-.78-.179-1.1-.022-.135-.043-.263-.063-.381-.1-.576-.16-.949-.183-1.075,0-.031-.008-.047-.008-.047s0,.016,0,.047c-.005.112-.019.419-.046.889-.008.135-.017.283-.026.445-.03.5-.072,1.134-.125,1.864-.03.41-.064.853-.1,1.323a105.274,105.274,0,0,1-3.014,18.748c-2.738,9.506-4.18,23.137-4.18,23.137H255.6a111.594,111.594,0,0,1,2.45-26.186c.81-3.755,1.093-10.833,1.157-16.932.013-1.2.017-2.357.015-3.447,0-.146,0-.29,0-.433-.013-4.007-.108-6.965-.162-7.167h22.714s-.159,2.964-.272,6.888q-.009.323-.019.657c-.029,1.082-.053,2.225-.07,3.392-.019,1.248-.027,2.522-.022,3.773v.026c.012,2.787.094,5.465.3,7.5.044.44.07.951.08,1.521",
    transform: "translate(627.442 -2193.232)",
    fill: "#191a1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72316",
    "data-name": "Path 72316",
    d: "M214.3,4754.844h0a2.03,2.03,0,0,1-.824-1.128c-.022-.135-.04-.311-.074-.506a2.239,2.239,0,0,0-2.288-2c-2.252-.235-3.765.1-4.3,1.109a4.113,4.113,0,0,0-.364,1.2c-.115.582-.229,1.083-.829,1.326a3.941,3.941,0,0,0-.094.451l-.393,3.592h9.654s-.3-2.7-.485-4.043",
    transform: "translate(676.487 -4218.779)",
    fill: "#c43d55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72317",
    "data-name": "Path 72317",
    d: "M780.2,4750.889c-.228-.133-.444-.271-.649-.411a3.855,3.855,0,0,1-1.271-2.313c-.3-1.076-1.79-.985-1.79-.985l-.056.005c-2.177.177-2.546,1.546-2.546,1.546-.775,1.439-.885,1.384-2.325,1.217s-1.441-1.383-2.16-.275-.831,4.262-.831,4.262a1.016,1.016,0,0,0-.554.665v1.052a.649.649,0,0,0,.61.775h5.039a.627.627,0,0,0,.663-.775c.887-.444,2.16.775,2.16.775h7.143c1.219-.11,1.383-.665,1.383-.665v-1.771c-.11-3.766-2.158-1.552-4.816-3.1",
    transform: "translate(129.021 -4214.926)",
    fill: "#c43d55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72318",
    "data-name": "Path 72318",
    d: "M1081.061,4845.189s-2.432.708-2.445,1.195c0,0,.122.3.357.235a9.036,9.036,0,0,1,2.5-.953.427.427,0,0,0-.407-.478",
    transform: "translate(-173.084 -4310.254)",
    fill: "#aa2945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72319",
    "data-name": "Path 72319",
    d: "M1132.655,4874.819a5.493,5.493,0,0,0-1.912,1.053.415.415,0,0,0,.476.353,9.223,9.223,0,0,1,1.98-1.084.54.54,0,0,0-.545-.321",
    transform: "translate(-223.783 -4339.068)",
    fill: "#aa2945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72320",
    "data-name": "Path 72320",
    d: "M1189.513,4894.645s-1.466.832-1.466,1.118a.794.794,0,0,0,.687.2,4.447,4.447,0,0,1,1.54-1.12.733.733,0,0,0-.761-.2",
    transform: "translate(-279.519 -4358.32)",
    fill: "#aa2945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72321",
    "data-name": "Path 72321",
    d: "M768.629,4992.968h5.039a.627.627,0,0,0,.663-.775c.887-.443,2.16.775,2.16.775h7.143c1.219-.11,1.383-.665,1.383-.665v-.982c-2.058.053-4.629.121-5.481.153-1.5.054-3.377-.777-4.706-1a57.8,57.8,0,0,0-6.257,0,1.017,1.017,0,0,0-.554.665v1.052a.649.649,0,0,0,.61.775",
    transform: "translate(129.021 -4451.469)",
    fill: "#aa2945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72322",
    "data-name": "Path 72322",
    d: "M188.223,5023.536h8.93a.794.794,0,0,0,.792-.792v-.145a.8.8,0,0,0-.792-.792h-8.93a.8.8,0,0,0-.792.792v.145a.794.794,0,0,0,.792.792",
    transform: "translate(693.701 -4482.035)",
    fill: "#aa2945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72323",
    "data-name": "Path 72323",
    d: "M252.15,4852.625q-.03.035-.056.073a.232.232,0,0,0-.055.192.176.176,0,0,0,.191.1.558.558,0,0,0,.215-.092,5.2,5.2,0,0,1,3.3-.665,21.3,21.3,0,0,1,2.826.76.412.412,0,0,0,.192.02.144.144,0,0,0,.122-.132c0-.068-.066-.115-.124-.151a6.946,6.946,0,0,0-3.6-1.051,6.141,6.141,0,0,0-2.19.416,1.988,1.988,0,0,0-.825.526",
    transform: "translate(630.868 -4316.57)",
    fill: "#aa2945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72324",
    "data-name": "Path 72324",
    d: "M255.278,4885.017c-.02.024-.038.048-.056.074a.232.232,0,0,0-.055.192.176.176,0,0,0,.191.1.558.558,0,0,0,.215-.092,5.189,5.189,0,0,1,3.3-.665,21.377,21.377,0,0,1,2.826.759.406.406,0,0,0,.192.021.145.145,0,0,0,.122-.133c0-.068-.066-.115-.124-.151a6.946,6.946,0,0,0-3.6-1.05,6.141,6.141,0,0,0-2.19.416,1.987,1.987,0,0,0-.825.525",
    transform: "translate(627.825 -4348.074)",
    fill: "#aa2945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72325",
    "data-name": "Path 72325",
    d: "M368.795,1125.056h0c-.1,2.948-1.681,4-1.681,4l-.025-.507-.009,0a70.924,70.924,0,0,1-7.953.984,57.949,57.949,0,0,1-5.965.105c-.389-.015-.78-.034-1.17-.059a31.7,31.7,0,0,1-6.211-.96v.687s-.1-.036-.253-.109a4.616,4.616,0,0,1-.505-.276c-.056-.036-.112-.073-.169-.113a2.841,2.841,0,0,1-.4-.339,1.65,1.65,0,0,1-.3-.414,6.4,6.4,0,0,1-.748-1.777c-.176-.8-.079-5.217-.075-5.425v-.007l1.021-9.7v0l1.163-7.667-.118-.951-.815-6.55,0-1.045a13.074,13.074,0,0,1,2.629-2.615l2.12-.85.621-.249.187-.075.8-.319.179-.071,1.079-.433,1.014-.406-.03-1.963-.048-3.129.063-.006.005-.443,2.32.221,2.321-.221.005.443-.048.073.066,3.015.045,2.043,2.156.864.915.366.105.042.642.258,2.1.84h0v0a7.48,7.48,0,0,1,2.794,2.323l-.291,2.332-.692,5.553-.118.951v0l1.626,10.706.139.918Z",
    transform: "translate(542.095 -652.416)",
    fill: "#5b93ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72326",
    "data-name": "Path 72326",
    d: "M611.517,1090.82c.547,2.686,2.507,4.673,4.841,4.673s4.3-1.995,4.843-4.687l-2.288-.864-.047-2.042-.07-3.015.051-.073-.005-.443-2.463.221-2.462-.221-.005.443-.067.006.051,3.129.032,1.963-1.076.406-1.145.433Z",
    transform: "translate(281.227 -652.404)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72327",
    "data-name": "Path 72327",
    d: "M696.274,1089.474l.08-.026.009,0,1.478,2.666a1.1,1.1,0,0,0,1.979,0l.1-.182c.028-.056.052-.114.075-.174l.018.008,1.27-2.293.015-.024.018.006v-4.317l-5-.609-.013,1.509Z",
    transform: "translate(198.79 -652.557)",
    fill: "#f3898b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72328",
    "data-name": "Path 72328",
    d: "M289.7,1317.486c-.253,3.054-.74,6.737-1.151,9.578-.1.66-.187,1.276-.27,1.827-.008.05-.015.1-.022.15a40.863,40.863,0,0,1-6.189-.653q-.382-.073-.759-.156-.279-.062-.553-.128l-.327-.081h0v.686l-.084-.032c-.046-.018-.109-.043-.184-.077a3.108,3.108,0,0,1-1.453-1.142,6.186,6.186,0,0,1-.793-1.777,53.442,53.442,0,0,1-.08-5.425v-.007l1.083-9.7v0l1.235-7.667-.125-.951-.865-6.55,0-1.045a13.567,13.567,0,0,1,2.789-2.615l2.908-1.1s.046-.708.157-1.326l1.075.861.3.244.039.055,3.271,4.635s.489,16.491,0,22.391",
    transform: "translate(605.806 -851.725)",
    fill: "#404966"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72329",
    "data-name": "Path 72329",
    d: "M2.6,1416.6a21.451,21.451,0,0,0,5.693,3.238s1.451-4.242,2.791-5.135h0L8.624,1408s1.8-8.759,2.518-15.822a36.855,36.855,0,0,0,.231-6.44,3.979,3.979,0,0,0-2.639,2.5l-.029.064c-1.067,2.42-6.015,16.033-7.9,18.577-1.9,2.568-.112,7.927,1.786,9.712",
    transform: "translate(876 -945.521)",
    fill: "#404966"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72330",
    "data-name": "Path 72330",
    d: "M211.543,1636.748l2.455,6.7c-.085-.094-5.575-6.235-5.361-6.9s5.271-13.973,5.423-15.618c-.721,7.064-2.518,15.822-2.518,15.822",
    transform: "translate(673.081 -1174.27)",
    fill: "#303752"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72331",
    "data-name": "Path 72331",
    d: "M302.736,2420.468a10.8,10.8,0,0,1,3.569-5.926l.807.79s-3.732,5.436-3.48,6.257Z",
    transform: "translate(581.553 -1946.156)",
    fill: "#303752"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72332",
    "data-name": "Path 72332",
    d: "M376.069,2704.59s-.357,3.675-.861,3.776a32.269,32.269,0,0,1-6.556-.709,2.057,2.057,0,0,1-.386-.148,10.4,10.4,0,0,1-.113-3.283q.033-.316.084-.655h0l.326.044.386.052.927.124c1.774.237,4.564.606,6.189.8",
    transform: "translate(517.996 -2227.273)",
    fill: "#303752"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72333",
    "data-name": "Path 72333",
    d: "M873.025,1325.681a6.19,6.19,0,0,1-.793,1.777,3.108,3.108,0,0,1-1.453,1.142c-.075.034-.139.06-.184.077l-.031.012-.053.019v-.686h0a37.54,37.54,0,0,1-7.828,1.018c-.01-.064-.019-.13-.029-.2-.082-.539-.17-1.138-.263-1.78-.411-2.841-.9-6.524-1.151-9.578-.489-5.9-.06-20.055-.06-20.055l3.327-6.939.043-.088.3-.244,1.075-.861c.111.618.157,1.326.157,1.326l2.908,1.1a13.567,13.567,0,0,1,2.79,2.615l0,1.045-.864,6.55-.125.951,1.234,7.667v0l1.083,9.7v.007a53.446,53.446,0,0,1-.08,5.425",
    transform: "translate(38.573 -851.725)",
    fill: "#404966"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72334",
    "data-name": "Path 72334",
    d: "M1164.664,1392.19c.721,7.064,2.517,15.822,2.517,15.822l-2.455,6.7h0c1.34.893,2.791,5.135,2.791,5.135a21.457,21.457,0,0,0,5.693-3.238c1.9-1.785,3.684-7.144,1.786-9.711s-6.921-16.409-7.925-18.642a3.977,3.977,0,0,0-2.638-2.5,36.829,36.829,0,0,0,.232,6.439",
    transform: "translate(-256.488 -945.533)",
    fill: "#404966"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72335",
    "data-name": "Path 72335",
    d: "M1177.665,1636.748l-2.455,6.7c.085-.094,5.575-6.235,5.361-6.9s-5.271-13.973-5.423-15.618c.721,7.064,2.518,15.822,2.518,15.822",
    transform: "translate(-266.972 -1174.27)",
    fill: "#303752"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72336",
    "data-name": "Path 72336",
    d: "M1123.9,2420.468a10.8,10.8,0,0,0-3.569-5.926l-.807.79s3.732,5.436,3.48,6.257Z",
    transform: "translate(-212.869 -1946.156)",
    fill: "#303752"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72337",
    "data-name": "Path 72337",
    d: "M930.079,2707.508l-.049.024c-1.137.541-6.4.932-6.893.832s-.861-3.776-.861-3.776c2.478-.292,7.666-1,7.828-1.018h0q.036.234.063.458c.008.066.016.132.022.2a10.372,10.372,0,0,1-.113,3.283",
    transform: "translate(-21.024 -2227.271)",
    fill: "#303752"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72338",
    "data-name": "Path 72338",
    d: "M572.2,1320.285c.875,3.4,1.705,4.948,5.739,5.419s6.1-5.419,6.1-5.419l-1.092-.352c-.543,2.693-2.505,4.687-4.843,4.687s-4.294-1.988-4.841-4.673Z",
    transform: "translate(319.464 -881.518)",
    fill: "#32677c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72339",
    "data-name": "Path 72339",
    d: "M888.384,1266.769c-.372.126-.652.209-.652.209a38.685,38.685,0,0,1,2.336-4.1,2.137,2.137,0,0,1,.314-.46c.044-.041.088-.087.132-.134.072-.088.143-.17.212-.244.046-.055.093-.11.138-.167a8.27,8.27,0,0,1,.816-.933c.016-.016.032-.029.049-.044a1.159,1.159,0,0,1,.425-.247c.389-.107,1.371.813,2.018,1.48l.128.133.174.185c.191.206.313.342.313.342l-.725.453-.216.135-.952.592-.118.073-1.387.865-2.07,1.29a.79.79,0,0,1-.305.344c-.2.076-.4.147-.582.209l-.052.032.006-.017",
    transform: "translate(12.575 -823.852)",
    fill: "#272e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72340",
    "data-name": "Path 72340",
    d: "M866.374,1314.976c.058-.062.121-.121.186-.18l.9-.368a32.867,32.867,0,0,0,4.118-2.629c.308-.224.577-.426.791-.587.334-.253.532-.41.532-.41s.644-.2.866.181,1.552,1.807,1.528,2.766a.145.145,0,0,1,0,.018l-.583-.047a9.266,9.266,0,0,0-3.38,1.388c-.148.111-.317.233-.5.362a12.941,12.941,0,0,1-3.758,1.825h0a5.7,5.7,0,0,0-1.537,1,4.607,4.607,0,0,1-.051-.721,3.789,3.789,0,0,1,.891-2.6",
    transform: "translate(34.214 -872.588)",
    fill: "#303752"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72341",
    "data-name": "Path 72341",
    d: "M461.239,1245.769l.071.042c.151.091.537.323,1.053.62l.17.1c.234.135.49.279.761.43.1.054.191.106.29.159.449.247.926.5,1.4.738a8.506,8.506,0,0,0,2.919,1.084s-.146-.338-.378-.836c-.128-.271-.281-.589-.451-.923s-.347-.678-.535-1.014l-.122-.214c-.177-.308-.359-.6-.535-.858-.078-.114-.156-.22-.232-.318a3.4,3.4,0,0,0-.23-.269c-.2-.209-.367-.378-.508-.509-.078-.073-.148-.135-.213-.187-.427-.346-.61-.273-1.016-.032a21.171,21.171,0,0,0-1.859,1.483l-.268.232c-.191.169-.315.276-.315.276",
    transform: "translate(427.39 -807.25)",
    fill: "#272e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72342",
    "data-name": "Path 72342",
    d: "M396.025,1309.022c.321-.31.457-.381,1.19-.414l.131-.007c.05,0,.1,0,.157-.005h0c.166-.007.354-.012.571-.016a1.017,1.017,0,0,1,.238.028h0a9.8,9.8,0,0,1,4.4,2.3,4.305,4.305,0,0,1,.995,1.256,4.919,4.919,0,0,1,.373,1.98,8,8,0,0,1-.111,1.408s-1.1-.958-2.012-1.841a37.727,37.727,0,0,0-5.194-3l-.007,0c-.142-.05-.238-.084-.276-.1a1.517,1.517,0,0,0-.92.193l-.01.007c-.028.015-.056.026-.081.038l-.069.033c-.04.019-.074.036-.091.046a.058.058,0,0,0-.014.009c-.241-.623.3-1.513.723-1.915",
    transform: "translate(491.579 -870.475)",
    fill: "#303752"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72343",
    "data-name": "Path 72343",
    d: "M651.553,1474.083h.589a.241.241,0,1,0,0-.483h-.589a.241.241,0,1,0,0,.483",
    transform: "translate(242.521 -1030.979)",
    fill: "#1d2435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72344",
    "data-name": "Path 72344",
    d: "M660.068,1496.849h0a.3.3,0,0,0,.3-.3v-18.105a.3.3,0,1,0-.595,0v18.105a.3.3,0,0,0,.3.3",
    transform: "translate(234.294 -1035.402)",
    fill: "#272e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72345",
    "data-name": "Path 72345",
    d: "M667.629,2152.9h0a.081.081,0,0,0,.081-.081v-.74a.081.081,0,0,0-.162,0v.74a.081.081,0,0,0,.081.081",
    transform: "translate(226.729 -1690.801)",
    fill: "#1d2435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72346",
    "data-name": "Path 72346",
    d: "M915.644,1482.949h.523a.262.262,0,1,0,0-.523h-.523a.262.262,0,1,0,0,.523",
    transform: "translate(-14.319 -1039.563)",
    fill: "#1d2435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72347",
    "data-name": "Path 72347",
    d: "M923.92,1506.488h0a.3.3,0,0,0,.3-.3v-18.1a.3.3,0,1,0-.595,0v18.1a.3.3,0,0,0,.3.3",
    transform: "translate(-22.333 -1044.777)",
    fill: "#272e44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72348",
    "data-name": "Path 72348",
    d: "M931.481,2162.539h0a.081.081,0,0,0,.081-.081v-.74a.081.081,0,1,0-.162,0v.74a.081.081,0,0,0,.081.081",
    transform: "translate(-29.898 -1700.176)",
    fill: "#1d2435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72349",
    "data-name": "Path 72349",
    d: "M1032.722,701.877c-1.684,1.253-2.384.54-2.384.54l-2.411-3.51s.053-.047.15-.129c.644-.544,3.221-2.636,4.98-2.829a1.307,1.307,0,0,1,1.436.657c1.252,2.376-.086,4.018-1.772,5.271",
    transform: "translate(-123.782 -274.604)",
    fill: "#e8887c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72350",
    "data-name": "Path 72350",
    d: "M298.092,713.417l-2.41,3.51s-.7.713-2.385-.54-3.024-2.895-1.772-5.27c.355-.674,1.038-.781,1.833-.586a11.488,11.488,0,0,1,3.582,1.962c.687.515,1.152.924,1.152.924",
    transform: "translate(592.935 -288.717)",
    fill: "#e8887c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72351",
    "data-name": "Path 72351",
    d: "M440.358,227.666c-.061.226-.1.352-.1.352a37.3,37.3,0,0,1-1.339,7.221c-1.08,3.549-4.752,4.572-7.992,4.745s-5.486-1.253-7.733-2.765-2.462-6.739-2.462-6.739-.122-.9-.25-2.264c-.331-3.492-.7-9.984.854-11.819a5.236,5.236,0,0,1,.981-.892l.006,0a6.737,6.737,0,0,1,1.469-.766,19.119,19.119,0,0,1,7.057-.8c.649.017,1.31.046,1.979.082,4.839.259,7.646,2.505,8.251,5.875.041.229.073.465.1.7a22.373,22.373,0,0,1-.818,7.066",
    transform: "translate(467.313 194.209)",
    fill: "#fda899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72352",
    "data-name": "Path 72352",
    d: "M461.946,822.915a3.5,3.5,0,1,0,3.494-3.292,3.4,3.4,0,0,0-3.494,3.292",
    transform: "translate(426.702 -394.906)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72354",
    "data-name": "Path 72354",
    d: "M868.566,822.915a3.388,3.388,0,1,0,3.387-3.292,3.341,3.341,0,0,0-3.387,3.292",
    transform: "translate(31.215 -394.906)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72360",
    "data-name": "Path 72360",
    d: "M357.167,271.715a5.236,5.236,0,0,0-.981.892c-1.555,1.835-1.185,8.327-.854,11.819a6.547,6.547,0,0,0-1.5-.612,16.751,16.751,0,0,1-.6-5.416,8.389,8.389,0,0,1,3.941-6.683",
    transform: "translate(532.464 138)",
    fill: "#743b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72361",
    "data-name": "Path 72361",
    d: "M1158.751,460.9a22.09,22.09,0,0,1-.423,3.432,5.076,5.076,0,0,0-1.6.531,22.373,22.373,0,0,0,.818-7.066,7.452,7.452,0,0,1,1.209,3.1",
    transform: "translate(-249.053 -42.99)",
    fill: "#743b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72362",
    "data-name": "Path 72362",
    d: "M293.7,12.48a7.508,7.508,0,0,1-2.4,4.94v0l-.728-.849-1.913,1.7-.345-1.3a2.6,2.6,0,0,1-.5-.129c-.058-.022-.116-.045-.173-.07-.037-.016-.074-.033-.11-.051a3.62,3.62,0,0,1-.96-.7c-.043-.044-.084-.087-.122-.128l-.028-.031-.053-.06a3.387,3.387,0,0,1-.282-.372,1.111,1.111,0,0,0,.258.587c.023.033.048.066.073.1h0c.019.025.039.05.059.073.069.084.139.163.2.231.034.037.066.07.094.1.07.072.119.118.127.125a4.43,4.43,0,0,1-3.117.184c-.06-.021-.119-.043-.176-.067s-.11-.047-.162-.072h0a3.246,3.246,0,0,1-.333-.183h0l-.083-.053h0a3.071,3.071,0,0,1-.394-.315h0l-.07-.068a1.979,1.979,0,0,1-.19-.22.229.229,0,0,0,.01.027.858.858,0,0,0,.164.231c.053.058.114.116.176.171h0c.1.09.2.173.292.239h0c.055.043.1.077.139.1h0c.029.022.05.036.061.043h0l.007.006-.176.051c-.146.039-.289.073-.43.1-.1.019-.2.034-.293.046a5.436,5.436,0,0,1-3.9-1.051l-.5-.251c.023.039.038.06.038.06a1.736,1.736,0,0,1-.232-.158l-1.005-.51h0a5.356,5.356,0,0,0,.718,2.2h0a5.842,5.842,0,0,1-3.153-.235l.091.246a5.108,5.108,0,0,1-1.931-.931,9.214,9.214,0,0,0,.436,1.294,7.291,7.291,0,0,1-1.262-.125l.266.363h-.013a6.742,6.742,0,0,1-1.639-.3l-.3,2.162a6.394,6.394,0,0,1-1.577-2.673l-.91.6c-2.373-1.332-2.409-4.285-2.073-6.5a22.06,22.06,0,0,1,.462-2.183c.253-1,1.757-2.6,3.33-4.106,1.152-1.108,2.341-2.168,3.1-2.911a7.041,7.041,0,0,1,4.754-1.6,3.072,3.072,0,0,1,2.367.118A12.426,12.426,0,0,1,282.43.011c.719.056,3.481,1.378,6.1,3.538h0a16.255,16.255,0,0,1,4.4,5.3,7.419,7.419,0,0,1,.767,3.626",
    transform: "translate(618.022 402.277)",
    fill: "#b95b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72363",
    "data-name": "Path 72363",
    d: "M800.35,138.618a8.213,8.213,0,0,1-1.253-.132,4.374,4.374,0,0,1-2.5-1.311,10.514,10.514,0,0,0-.845-1.018,3.138,3.138,0,0,0-2.45-.57c-.857.1-1.7.358-2.558.392-1.765.068-4-1.052-4.6-2.819a16.609,16.609,0,0,0,1.546.621,2.359,2.359,0,0,0,1.716-.18,5.725,5.725,0,0,0,.826-.683,4.573,4.573,0,0,1,5.477-.254,5.515,5.515,0,0,0-.534-2.976,16.244,16.244,0,0,1,4.4,5.3,7.427,7.427,0,0,1,.768,3.627",
    transform: "translate(111.376 276.139)",
    fill: "#ce7272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72364",
    "data-name": "Path 72364",
    d: "M283.132,178.556a2.807,2.807,0,0,0-2.6.194,11.071,11.071,0,0,1-2.449,1.162,3.888,3.888,0,0,1-2.324-.266,11.2,11.2,0,0,0-1.936-.833,3.815,3.815,0,0,0-3.035.906,22.285,22.285,0,0,1,.462-2.183c.254-1,1.757-2.6,3.33-4.106a4.765,4.765,0,0,1,.755,1.307,3.885,3.885,0,0,0,.921,1.819c.726.575,1.772.29,2.686.141a4.849,4.849,0,0,1,2.466.166,2.828,2.828,0,0,1,1.723,1.693",
    transform: "translate(612.626 233.594)",
    fill: "#ce7272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72365",
    "data-name": "Path 72365",
    d: "M648.9,457.118l-1.005-.51h0a5.357,5.357,0,0,0,.718,2.2c-.049-.029-2-1.215-1.747-4.71a11.216,11.216,0,0,0,2.034,3.025",
    transform: "translate(246.867 -39.385)",
    fill: "#743b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72366",
    "data-name": "Path 72366",
    d: "M727.011,275.239a12.648,12.648,0,0,1-.789,2.342l.323,1.577-.728-.849-1.913,1.7-.345-1.3h0a2.655,2.655,0,0,1-.5-.128c-.058-.022-.116-.045-.173-.07l-.11-.051a3.623,3.623,0,0,1-.96-.7c-.044-.044-.084-.087-.122-.129l-.028-.031-.053-.06a3.4,3.4,0,0,1-.282-.372,1.111,1.111,0,0,0,.258.587c.023.033.048.066.073.1h0l.059.073c.069.084.139.163.2.231.034.037.066.07.094.1.07.072.119.118.127.125h0a4.427,4.427,0,0,1-3.118.183c-.06-.021-.119-.043-.176-.067s-.11-.047-.162-.072h0a3.041,3.041,0,0,1-.333-.183h0l-.083-.053h0a3.024,3.024,0,0,1-.394-.315h0l-.07-.068a1.966,1.966,0,0,1-.19-.22v0a.165.165,0,0,0,.011.029.859.859,0,0,0,.164.231c.053.057.113.115.176.171h0c.1.089.2.172.292.239h0l.139.1h0l.061.043h0l.009.005h0l-.176.051c-.146.039-.29.073-.43.1-.1.019-.2.034-.293.046a5.436,5.436,0,0,1-3.9-1.051l-.5-.251c.023.039.038.06.038.06a1.74,1.74,0,0,1-.232-.158l.194.1a3.205,3.205,0,0,1-.447-1.314,6.252,6.252,0,0,0,4.868,2.214s-2.093-1.756-1.94-4.022c0,0,1.845,3.475,4.066,4.1a4.036,4.036,0,0,0,1.488-.212,4.815,4.815,0,0,1-1.124-2.665s1.977,2.242,3.3,2.61l-.683-2.761a9.157,9.157,0,0,1,1.57,3.868s2.222-2.52,2.348-4.633-2.583-5.371-2.583-5.371,3.526,2.749,2.965,6.135",
    transform: "translate(182.784 140.539)",
    fill: "#743b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72367",
    "data-name": "Path 72367",
    d: "M356.535,538.781h0a5.841,5.841,0,0,1-3.153-.235l.092.247a5.119,5.119,0,0,1-1.932-.932,9.233,9.233,0,0,0,.436,1.294,7.333,7.333,0,0,1-1.262-.125l.267.363h-.014a6.719,6.719,0,0,1-1.639-.3l-.3,2.162a6.4,6.4,0,0,1-1.578-2.673l-.909.6.954-2.375a6.323,6.323,0,0,0,1.265,3.246l.005-2.679a2.43,2.43,0,0,0,1.324,1.491,4.663,4.663,0,0,1-.51-2.256,3.143,3.143,0,0,0,2.018,2.175,9.827,9.827,0,0,1-.884-2.459,9.9,9.9,0,0,0,2.121,1.776c-.114-.211-.37-1.011-.37-1.011.974.974,4.067,1.694,4.067,1.694",
    transform: "translate(538.944 -119.361)",
    fill: "#743b32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72368",
    "data-name": "Path 72368",
    d: "M772.13,227.259a6.719,6.719,0,0,0,6.481,5.689l-.5-1.833a5.374,5.374,0,0,0,4.266,1.986s-3.922-1.222-4.686-3.551c0,0-.611,1.642.153,2.52,0,0-3.57-.038-5.718-4.811",
    transform: "translate(125.011 181.238)",
    fill: "#aa4646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72369",
    "data-name": "Path 72369",
    d: "M412.1,211.919s-2.551,4.4-.5,8.057c0,0-3.246-2.062.5-8.057",
    transform: "translate(476.933 196.158)",
    fill: "#aa4646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72370",
    "data-name": "Path 72370",
    d: "M310.9,255.151s-4.5,4.494-1.009,9.693c0,0-2.466-5.646,1.009-9.693",
    transform: "translate(575.884 154.111)",
    fill: "#aa4646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72371",
    "data-name": "Path 72371",
    d: "M565.12,211.919a7.06,7.06,0,0,0,3.428,6.415s-4.5-.764-3.428-6.415",
    transform: "translate(326.513 196.158)",
    fill: "#aa4646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72372",
    "data-name": "Path 72372",
    d: "M983.752,179.844s6.835,5.46,4.811,9.317c0,0,3.7-3.4-4.811-9.317",
    transform: "translate(-80.817 227.355)",
    fill: "#aa4646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72373",
    "data-name": "Path 72373",
    d: "M513.365,211.919s-2.68,3.489-1.149,6.794c0,0-.773-3.676,1.034-5.992Z",
    transform: "translate(378.268 196.158)",
    fill: "#aa4646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72374",
    "data-name": "Path 72374",
    d: "M411.239,2736.732c-.022.619-.043,1.278-.063,1.967a88.224,88.224,0,0,1-11.624.872h-.009a81.134,81.134,0,0,1-10.647-.592c0-.748-.008-1.459-.015-2.123a32.192,32.192,0,0,0,6.556.708c.5-.1.861-3.776.861-3.776.008-.05.015-.1.022-.15.39.025.781.044,1.17.059a57.948,57.948,0,0,0,5.965-.105c.01.066.019.132.029.2,0,0,.358,3.675.861,3.776s5.756-.291,6.893-.832",
    transform: "translate(497.768 -2256.471)",
    fill: "#08090a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup43080);
export default __webpack_public_path__ + "static/media/group-43080.44215f4457d8120b45ed6663a162c341.svg";
export { ForwardRef as ReactComponent };